<template>
  <div>

    <CommonAlert ref="mainAlert" :default-timeout="5000"/>


    <div :class="generatorMainSectionClass" ref="generatorTableSection">
      <div v-if="!currentGroupOrder || currentGroupOrder.removed === true">
        <!--        <h4 class="alert-heading">Zamówienie zostało usunięte!</h4>-->
        <!--        <p>To zamówienie zostało usunięte. Nie możesz go edytować ani przeglądać.</p>-->
        <!--        <hr>-->

        <div style="display: flex; justify-content: center; align-items: center; height: 100px;">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Pobieranie danych...</span>
          </div>
        </div>
      </div>
      <div v-else class="generator-table-section">
        <PackageOrderGeneratorDetailsSection :groupOrder="currentGroupOrder"
                                             @openOrderGeneratorDetailsModal="openOrderGeneratorDetailsModal"
                                             @openOrderGeneratorDrugstoresList="openOrderGeneratorDrugstoresList"
                                             @openOrderGeneratorProductsList="openOrderGeneratorProductsList"
                                             @onShowLogisticContainer="onLogisticContainerOpened"
                                             @onSelectValue="setNewLogisticValueOnAmountFocusedCell"
                                             @onSetValueForAll="setLogisticValueForAllWithWarning($event,true)"
                                             @onRefreshList="refreshItemsData"
                                             :selectedProductData="selectedProductData"
                                             :selectedDrugstoreData="selectedDrugstoreData"
                                             :selectedProductStock="selectedProductStock"
                                             :selectedProductSelling="selectedProductSelling"
                                             :selectedProductSellingDetails="selectedProductSellingDetails"
                                             :selectedItemData="selectedItemData"
                                             :lastStockDates="lastStockDates"
                                             :settingAmountsAvailableOptions="settingAmountsAvailableOptions"
                                             :isEmpty="isOrderEmpty"
                                             :orderTableHeaders="orderGeneratorTableHeaders"
                                             @openSellingRangesModal="openSellingRangesModal"
                                             @openColumnManagementModal="openColumnManager"
                                             @openDiscountsModal="openDiscountManager"

        />
        <div :class="generatorTableSectionClass" style="top: 232px;"  >

          <div ref="generatorTableView" class="scrollable-content">
            <div v-if="showMassGeneratorTableActions" class="products-mass-actions-section">
              <div class="empty-product-info">Akcje:
                <div v-if="!isOrderPublished && groupViewMode" class="btn btn-danger btn-sm mass-actions-btn"
                     @click="removeItemsFromOrderWithWarning()"><i class="fas fa-trash-alt"></i>Usuń pozycje
                </div>
                <div v-if="isOrderPublished" class="btn btn-secondary btn-sm mass-actions-btn"
                     @click="ignoreItems()"><i class="fas fa-ban"></i>Zignoruj pozycje
                </div>
                <div v-if="isOrderPublished" class="btn btn-info btn-sm mass-actions-btn"
                     @click="unIgnoreItems()"><i class="fas fa-check"></i>Odignoruj pozycje
                </div>
                <div class="btn btn-outline-warning btn-sm mass-actions-btn"
                     @click="addNotificationsToItemsWithWarning()">Dodaj uwagi
                </div>

                <BDropdown
                    v-if="!isOrderPublished"
                    text="Ustaw ilości dla zaznaczonych"
                    variant="primary"
                    size="sm"
                >
                  <BDropdownItem
                      v-for="option in settingAmountsAvailableOptions"
                      :key="option.key"
                      @click="setLogisticValueForAllWithWarning(option,false)"
                  >
                    {{ option.label }}
                  </BDropdownItem>
                </BDropdown>
              </div>
            </div>
            <CommonTableFilterSection2 :filters-fetch-method="packagesModule.httpGetOrderGeneratorAvailableFilters"
                                       :filters-fetch-params="{orderGroupGuid: currentOrderGroupGuid}"
                                       @onSelectedFilters="updateFilters($event)"
                                       filter-main-panel-background-color="#e9ecef"
                                       style="margin-top:8px;"
                                       ref="filterSection"
            >

              <template #filter-left-panel>
                <div class="col-md-3 justify-start">
                  <b-pagination
                      v-model="currentPage"
                      size="sm"
                      :total-rows="itemsTotalElements"
                      :number-of-pages="itemsTotalPages"
                      :per-page="50"
                      :first-text="currentPage != 1 ? '1' : '||'"
                      :last-text="itemsTotalPages > 1 ? itemsTotalPages.toString() : '||'"
                      style="margin-bottom: 4px;"
                  />
                </div>
              </template>
              <template #filter-additional-buttons>


                <div class="btn d-flex align-items-center border rounded px-3 btn-sm shadow-sm"
                     style="background-color: #eff2f7">
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" role="switch" id="groupViewModeSwitch"
                           v-model="groupViewMode" @change="handleGroupViewModeChange">
                    <label class="form-check-label" for="groupViewModeSwitch">Grupowanie</label>
                  </div>
                </div>
                <div class="btn d-flex align-items-center border rounded px-3 btn-sm shadow-sm"
                     style="background-color: #eff2f7">
                  <div class="form-check form-switch mb-0">
                    <input class="form-check-input" type="checkbox" role="switch" id="groupViewModeSwitch"
                           v-model="drugstoresInGridView" @change="handleDrugstoresInGridViewChange"   :disabled="!groupViewMode">
                    <label class="form-check-label" for="groupViewModeSwitch">Na apteki</label>
                  </div>
                </div>

                <button class="btn btn-outline-secondary btn-sm shadow-sm" @click="openColumnManager"
                        title="Zarządzaj kolumnami">
                  <i class="fas fa-columns"></i>
                </button>


              </template>


            </CommonTableFilterSection2>

            <div v-if="isLoading" class="d-flex flex-column align-items-center justify-content-center p-2 text-muted">
              <div class="spinner-border text-primary mb-2" role="status" style="width: 2rem; height: 2rem;">
                <span class="visually-hidden">Loading...</span>
              </div>
              <span class="small fw-semibold">Pobieranie danych zamówienia...</span>
            </div>
            <div v-else>
              <PackageOrdersGeneratorTable ref="packagesOrderPreparedExcelView" id="packagesOrderPreparedExcelView"
                                           :data="orderGeneratorTableData" :headers="availableHeaders"
                                           :key="refreshTrigger"
                                           @cell-click="onCellClick"
                                           @cell-focus="onCellFocus"
                                           @cell-dbclick="onCellDbClick"
                                           @cell-blur="onCellBlur"
                                           @on-context-menu="openContextMenuForRow"
                                           @page-changed="onPageChanged"
                                           @select-row="onSelectRow"
                                           @mass-clear-select="onMassClearSelect"
                                           @un-select="onSelectRow"
                                           @cell-update="onCellUpdate"
                                           @sort="onSort"
                                           :isPublished="isOrderPublished"
                                           :cell-style="setCellStyle"
                                           :stickyHeaderTop="46"
                                           :stickyScrollbarBottom="0"
                                           @first-row-reached="onFirstRowReached"
                                           @last-row-reached="onLastRowReached"
              >

                <template #generator-table-header>


                </template>

              </PackageOrdersGeneratorTable>
              <div class="col-md-3 justify-end">
                <b-pagination
                    v-model="currentPage"
                    size="sm"
                    :total-rows="itemsTotalElements"
                    :number-of-pages="itemsTotalPages"
                    :per-page="50"
                    :first-text="currentPage != 1 ? '1' : '||'"
                    :last-text="itemsTotalPages > 1 ? itemsTotalPages.toString() : '||'"
                    style="margin-bottom: 4px;"
                />
              </div>
            </div>

          </div>

          <ContextMenu
              ref="ctxMenu"
              :options="menuOptions"
              @option-selected="handleMenuAction"
          />


          <div ref="generatorTableViewEnd"></div>


        </div>


        <b-modal
            v-model="showOrderGeneratorDrugstoresList"
            id="drugstores-select-list-modal"
            scrollable
            title="Dostępne apteki"
            title-class="font-18"
            hide-footer
            style="z-index:100010!important;"
            size="xl"
        >
          <div v-if="showOrderGeneratorDrugstoresList">
            <div class="d-flex flex-wrap align-items-end justify-content-end gap-2 mb-2">
              <button class="btn btn-success btn-sm" @click="openDrugstoresSelectList">Dodaj apteki do zamówienia
              </button>
            </div>

            <div class="row">
              <CommonTable2
                  :table="orderDrugstoresTableData"
                  rowIdentifier="drugstoreClientId"
                  @onItemAction="runDrugstoresTableAction($event)"
                  @onMassAction="runDrugstoresMassAction($event)"
                  :sortColumn="null"
                  :sortDirection="null"
                  :enableRowSelection="false"
                  :key="orderDrugstoresTableData.data"
              />
            </div>

            <DrugstoreOrGroupsTabsModal
                :showModal="showDrugstoresSelectList"
                @update:showModal="showDrugstoresSelectList = $event"
                title="Dostępne apteki / grupy aptek"
                ok-title="Dodaj"
                :multiselectDrugstores="true"
                :multiselectGroups="true"
                :disableInitiallyCheckedItems="true"
                :ignoreInitiallyCheckedItems="true"
                :selectedDrugstoresData="orderDrugstoresCurrent"
                :selectedGroupsData="[]"
                @onApply="handleApplyFromDrugstoresOrGroups"


            />


          </div>


        </b-modal>
        <div v-if="showOrderGeneratorProductsList">
          <ProductOrCategoryTabsModal
              :showModal="showOrderGeneratorProductsList"
              @update:showModal="showOrderGeneratorProductsList = $event"
              title="Baza centralnych towarów i kategorii"
              :showAddButton="false"
              ok-title="Dodaj"
              :multiselect="true"
              @onApply="handleApplyFromProductsOrCategories"
              :showMassActions="false"
              :showRowActions="false"
              :selectedProductsData="centralProductsGuids"
              :visibleColumnsFilter="['id','name','bloz','ean','manufacturer','parentCategoryPath']"
              :selectedCategoriesData="[]"
              :enableRowSelection="false"
              :resetSelectionAfterApply="true"
          />
        </div>


        <div v-if="showOrderDetailsModal">

          <PackageOrderFormModal :showModal="showOrderDetailsModal"
                                 @update:showModal="showOrderDetailsModal = $event"
                                 @onSave="saveOrder"
                                 :initialPackageOrderData="currentGroupOrder"
          />
        </div>


        <ProductsSellingCustomDateRangesModal
            v-model:showModal="isRangesModalVisible"
            :packageOrderGroupGuid="currentOrderGroupGuid"
            @rangesUpdated="handleRangesUpdated"
        />

        <PackageDiscountsListModal
            v-if="showDiscountsModal"
            v-model:showModal="showDiscountsModal"
            :currentPackageOrder="currentGroupOrder"
            @onPackageDiscountSave="onPackageDiscountSave"
            @onPackageDiscountDelete="onPackageDiscountDelete"
        />

        <TableColumnManagerModal
            v-model:showModal="showColumnManager"
            :allHeaders="orderGeneratorTableHeaders"
            :currentVisibleKeys="visibleHeaderKeys"
            @onApply="updateVisibleColumns"
        />


      </div>


    </div>

  </div>

</template>

<script>
import {log} from "@/state/pinia/log";
import PackageOrdersGeneratorTable from "./PackageOrdersGeneratorTable.vue";
import Swal from "sweetalert2";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";

import {BModal, BPagination} from "bootstrap-vue-next";

// import DrugstoreListModal from "@/views/DrugstoreCommonManager/DrugstoreListModal.vue";
import ProductOrCategoryTabsModal from "@/views/DrugstoreCommonManager/ProductOrCategoryTabsModal.vue";
import {packageOrderDrugstoresListTableStructure} from "./data/packageOrderDrugstoresListTableStructure";
import PackageOrderGeneratorDetailsSection from "@/views/PackagesManager/PackageOrderGeneratorDetailsSection.vue";
import PackageOrderFormModal from "@/views/PackagesManager/PackageOrderFormModal.vue";
import {packagesHelperMethods} from "@/views/PackagesManager/helper/packagesHelperMethods";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
import {useLayoutStore} from "@/state/pinia";
import ProductsSellingCustomDateRangesModal from "@/views/PackagesManager/ProductsSellingCustomDateRangesModal.vue";
import dateFormat from "dateformat";

import TableColumnManagerModal from "@/components/widgets/TableColumnManagerModal.vue";
import PackageDiscountsListModal from "@/views/PackagesManager/PackageDiscountsListModal.vue";
import CommonTableFilterSection2 from "@/components/widgets/CommonTableFilterSection2.vue";
import ContextMenu from "@/components/widgets/ContextMenu.vue";
import router from "@/router";
import DrugstoreOrGroupsTabsModal from "@/views/DrugstoreCommonManager/DrugstoreOrGroupsTabsModal.vue";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";
import CommonAlert from "@/components/widgets/CommonAlert.vue";
import {USER_PROFILE_CONFIG_VIEW_KEYS} from "@/helpers/userProfileConfigViewKeys";
import {
  applyTableUserProfileSettings, findSettingByKey,
  loadUserProfileViewConfigRuntime, parseJsonSettingValue, saveGroupingViewSettingRuntime, saveSortingSettingRuntime,
  saveVisibleColumnsRuntime
} from "@/helpers/userProfileConfigHelper";

export default {
  name: "PackagesManagerOrdersGeneratorList1D",
  props: {
    editOrderGroupGuid: {
      type: String,
      required: false,
    },
    displayInBootstrapRow: {
      type: Boolean,
      default: () => false
    },
  },
  components: {
    CommonAlert,
    DrugstoreOrGroupsTabsModal,
    ContextMenu,
    CommonTableFilterSection2,
    PackageDiscountsListModal,
    TableColumnManagerModal,
    ProductsSellingCustomDateRangesModal,
    PackageOrderFormModal,
    PackageOrderGeneratorDetailsSection,
    BPagination,
    ProductOrCategoryTabsModal,
    // DrugstoreListModal,
    BModal,
    CommonTable2,
    PackageOrdersGeneratorTable: PackageOrdersGeneratorTable
  },
  computed: {
    packagesModule() {
      return usePackagesManagerModule();
    },
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
    lazyloaderModule() {
      return useLazyLoaderModule();
    },

    layoutStore() {
      return useLayoutStore();
    },

    layout: {
      get() {
        return this.layoutStore.layoutType;
      },
      set(layout) {
        this.layoutStore.changeLayoutType(layout);
      }

    },
    generatorTableSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'generator-table-container-vertical windows-like-breadcrumb-card shadow-sm scrollable-container';
      } else {
        return 'generator-table-container windows-like-breadcrumb-card shadow-sm scrollable-container';
      }
    },
    generatorMainSectionClass() {
      if (this.layout === 'vertical' || this.displayInBootstrapRow) {
        return 'row package-orders-generator-site';
      } else {
        return 'package-orders-generator-site';
      }
    },
    isOrderEmpty() {
      return this.centralProductsGuids == null || this.centralProductsGuids.length === 0
    },

    isOrderPublished() {
      return this.currentGroupOrder && this.currentGroupOrder.central === true;
    },

    currentOrderGroupGuid() {
      if (this.currentGroupOrder && this.currentGroupOrder.groupGuid && this.currentGroupOrder.groupGuid.length > 0) {
        return this.currentGroupOrder.groupGuid;
      } else {
        return this.$route.query.orderGroupGuid;
      }
    },
    availableHeaders() {
      if (!this.visibleHeaders) {
        return [];
      }

      return this.visibleHeaders;
    }
  },
  data() {
    return {
      showSendMailModal: false,
      showSendMailAlert: false,
      sendMailAlertType: '',
      sendMailAlertContent: '',
      mailContent: {
        sendMailDialogTitle: '',
        mailMessage: '',
        mailSubject: '',
        mailTo: '',
        mailCc: '',
        mailAttachmentName: ''
      },
      currentGroupOrder: null,
      editContextOn: false,
      currentPage: 0,
      sortingDirection: "ASC",
      sortingKey: "listIndex",
      selectedFilters: [],
      itemsTotalPages: 1,
      itemsTotalElements: 0,
      searchRequest: {
        searchPhrase: null,
        searchKey: null,
      },
      selectedProductData: null,
      selectedDrugstoreData: null,
      selectedProductStock: null,
      selectedProductSelling: null,
      selectedProductSellingDetails: null,
      selectedItemData: null,
      lastStockDates: null,

      orderGeneratorTableData: [],
      orderGeneratorTableHeaders: [],
      isLogisticContainerOpen: false,
      showOrderGeneratorDrugstoresList: false,
      showDrugstoresSelectList: false,
      orderDrugstoresTableData: {},

      showOrderGeneratorProductsList: false,
      showOrderDetailsModal: false,
      orderProductsTableData: {},
      taskDrugstoresTableHeaders: packageOrderDrugstoresListTableStructure.headers,
      taskDrugstoresTableMassActions: packageOrderDrugstoresListTableStructure.massActions,
      centralProductsGuids: [],
      showOrderDetailsForm: true,
      orderDrugstoresCurrent: [],
      selectedItemsGuids: [],
      currentFocusedCell: null,
      logisticDetailsDebounceTimeout: null,
      logisticContainerOpened: false,
      settingAmountsAvailableOptions: [
        // {key: "stock.activeStock", label: "Stan aktywny apteki"},
        // {key: "stock.bufferStock", label: "Ilość obecna w kolejce"},
        // {key: "stock.holdonStock", label: "Ilość wstrzymana w aptece"},
        // {key: "stock.sumStock", label: "Stan sumaryczny apteki"},
        {key: "stock.norm", label: "Norma"},
        {key: "stock.minStock", label: "Minimalny stan"},
        {key: "selling.soldIn30Days", label: "Sprzedaż 30 dni"},
        {key: "selling.soldIn45Days", label: "Sprzedaż 45 dni"},
        {key: "selling.soldIn60Days", label: "Sprzedaż 60 dni"},
        {key: "selling.soldIn90Days", label: "Sprzedaż 90 dni"},
        {key: "selling.soldIn120Days", label: "Sprzedaż 120 dni"},
        {key: "selling.soldIn150Days", label: "Sprzedaż 150 dni"},
        {key: "selling.soldIn180Days", label: "Sprzedaż 180 dni"},
        {key: "selling.soldIn300Days", label: "Sprzedaż 300 dni"},
        {key: "selling.soldIn360Days", label: "Sprzedaż 360 dni"},
      ],
      showMassGeneratorTableActions: false,
      isRangesModalVisible: false,
      showDiscountsModal: false,
      showColumnManager: false,
      visibleHeaders: [],
      visibleHeaderKeys: [],
      dateRanges:[],
      packageDiscounts: [],
      groupViewMode: false,
      drugstoresInGridView: false,
      menuOptions: [
        {
          text: "Pokaż dla aptek",
          icon: "edit",
          action: "show-for-drugstores",
          class: "btn btn-info",
          enabled: true,
        },

      ],
      heartbeatTimer: null,
      isLoading: false,
      refreshTrigger: 0,
      currentViewKey: USER_PROFILE_CONFIG_VIEW_KEYS.PACKAGE_ORDER_TABLE,
      currentViewContext: null,
      isApplyingUserProfileConfig: false,
      sellingColumnsColors : [
        "#FDECEC", // bardzo jasny róż
        "#EEF4FF", // bardzo jasny błękit
        "#EDFBF3", // bardzo jasna mięta
        "#FFF8E8", // bardzo jasny krem / piaskowy
        "#F4EEFF", // bardzo jasny lawendowy
        "#EEF7F2"  // bardzo jasny szaro-zielony
      ],


    }
  },
  methods: {

    openContextMenuForRow(event) {
      const rowData = event.record
      const rowPos = event.rowPos;
      const handledEvent = event.event
      this.$refs.ctxMenu.show({event: handledEvent, item: rowData});
    },

    // 2. Obsługa wybranej akcji
    handleMenuAction(payload) {
      const {action, item} = payload;

      if (action === "show-for-drugstores") {
        this.filterOnlyProduct(item);
      }
    },

    filterOnlyProduct(item) {

      console.log("filterOnlyProduct item:", item);

      const prodFilter = {
        key: 'centralProduct.bloz',
        selectedValues: item ? [item.bloz] : [],
      }
      this.updateFilters([prodFilter]);

    },


    updateVisibleColumns(newVisibleKeys) {
      console.log("updateVisibleColumns newVisibleKeys:", newVisibleKeys);
      this.visibleHeaderKeys = newVisibleKeys;
      this.visibleHeaders = this.orderGeneratorTableHeaders.filter(header => this.visibleHeaderKeys.includes(header.key));
      this.saveVisibleColumns(this.visibleHeaders)
    },
    onPackageDiscountSave(event){
      console.log("onPackageDiscountSave event:", event);
      this.refreshItemsData('packageDiscountSave',false,true,false);
    },
    onPackageDiscountDelete(event){
      console.log("onPackageDiscountDelete event:", event);
      this.refreshItemsData('packageDiscountDelete',false,true,false);
    },
    openDiscountManager() {
      if (this.isOrderPublished) {
        Swal.fire({
          title: "Zamówienie zostało opublikowanie",
          text: "Nie możesz zmieniać składu rabatów w opublikowanym już zamówieniu.",
          icon: "warning",
          customClass: {
            container: "swal-highest"
          },
        })
        return
      }
      this.showDiscountsModal = true;
    },

    openColumnManager() {
      this.showColumnManager = true;
    },
    openSellingRangesModal() {
      this.isRangesModalVisible = true;
    },
    handleRangesUpdated() {
      this.refreshItemsData("rangesUpdated",true,false,false);
    },

    setCellStyle(record, item) {
      for (let i = 0; i < this.dateRanges.length; i++) {
        const range = this.dateRanges[i];
        if (item.name === range.rangeKey) {
          return {
            fontStyle: 'italic'
          }
        }
      }

      if(item.name === "amount" || item.name === "calculatedDiscountPercentage"){
        return {
          fontWeight: '600'
        }
      }
      if(item.name.endsWith("_CalculatedDemand")){
        return {
          fontWeight: '600'
        }
      }

      return {}
    },
    saveOrder(result) {
      console.log("Saving order (Order view 1D): ", result);
      packagesHelperMethods.saveGroupOrderFormData(result, this.currentGroupOrder).then((response) => {
        this.currentGroupOrder = response.data.payload;
      })

      this.showOrderDetailsModal = false
    },
    onLogisticContainerOpened(event) {
      console.log("Opening logistic container event:", event);
      if (event.isOpened) {
        this.isLogisticContainerOpen = event.isOpened;
      } else {
        this.isLogisticContainerOpen = false;

      }
    },

    openDrugstoresSelectList() {
      if (this.isOrderPublished) {
        Swal.fire({
          title: "Zamówienie zostało opublikowanie",
          text: "Nie możesz zmieniać składu aptek w opublikowanym już zamówieniu.",
          icon: "warning",
          customClass: {
            container: "swal-highest"
          },
        })
        return
      }
      this.showDrugstoresSelectList = true
    },
    openOrderGeneratorDetailsModal() {
      if (this.isOrderPublished) {
        Swal.fire({
          title: "Zamówienie zostało opublikowanie",
          text: "Nie możesz zmieniać szczegółów w opublikowanym już zamówieniu.",
          icon: "warning",
          customClass: {
            container: "swal-highest"
          },
        })
        return
      }
      this.showOrderDetailsModal = true;
    },

    openOrderGeneratorDrugstoresList() {
      if (this.isOrderPublished) {
        Swal.fire({
          title: "Zamówienie zostało opublikowanie",
          text: "Nie możesz zmieniać składu aptek w opublikowanym już zamówieniu.",
          icon: "warning",
          customClass: {
            container: "swal-highest"
          },
        })
        return
      }
      this.fetchOrderDrugstores().then(() => {
        this.showOrderGeneratorDrugstoresList = true;
      })

    },

    notifyDrugstoresTableNewData(newDrugstoresData) {
      this.orderDrugstoresTableData = {
        headers: [],
        massActions: [],
        data: []
      }

      this.orderDrugstoresTableData['headers'] = this.taskDrugstoresTableHeaders;
      this.orderDrugstoresTableData['massActions'] = this.taskDrugstoresTableMassActions;
      newDrugstoresData.forEach(drugstoreRecord => drugstoreRecord['actions'] = [])  // switching off default drugstores actions


      this.orderDrugstoresTableData['data'] = newDrugstoresData;
    },

    openOrderGeneratorProductsList() {
      if (this.isOrderPublished) {
        Swal.fire({
          title: "Zamówienie zostało opublikowanie",
          text: "Nie możesz składu towarowego w opublikowanym już zamówieniu. Możesz jedynie oznaczać towary jako zignorowane.",
          icon: "warning",
          customClass: {
            container: "swal-highest"
          },
        })
        return
      }


      if (!this.orderDrugstoresCurrent || this.orderDrugstoresCurrent.length === 0) {
        Swal.fire({
          title: "Najpierw dodaj aptekę!",
          text: "Aby dodawać towary, najpierw dodaj conajmniej jedna aptekę",
          icon: "error",
          customClass: {
            container: "swal-highest"
          },

        })
        return
      }


      this.showOrderGeneratorProductsList = true;

    },


    fetchOrderDrugstores() {
      this.orderDrugstoresTableData['headers'] = this.taskDrugstoresTableHeaders;
      this.orderDrugstoresTableData['massActions'] = this.taskDrugstoresTableMassActions;

      const currentOrderItemsDrugstores = this.orderDrugstoresCurrent
      if (currentOrderItemsDrugstores.length === 0) {
        this.orderDrugstoresTableData['data'] = []
        return new Promise((resolve) => {
          resolve({});
        });
      }


      this.notifyDrugstoresTableNewData(this.orderDrugstoresCurrent)
      return new Promise((resolve) => {
        resolve({});
      });
    },

    runDrugstoresTableAction(event) {
      log.log("table action")
      log.log(event)
      if (event.action.action === "delete-from-order") {
        this.removeDrugstoresFromOrderWithWarning([event.item])

      }

    },
    runDrugstoresMassAction(event) {
      log.log("runMassAction action")
      log.log(event)
      if (event.action.action === "delete-from-order") {

        //copy of this.orderDrugstoresCurrent
        const orderDrugstoresCurrent = JSON.parse(JSON.stringify(this.orderDrugstoresCurrent))
        // checking if orderDrugstoresCurrent have at leas 1 element after we remove all of event.itemsData.items from it
        if (orderDrugstoresCurrent.length - event.items.length <= 0) {
          Swal.fire({
            title: "Uwaga",
            text: "Nie możesz usunąć wszystkich aptek z zamówienia, spowoduje to usunięcie całego zamówienia. Zostaw na liście conajmniej jedna aptekę.",
            icon: "warning",
            customClass: {
              container: "swal-highest"
            },
          })
          return;
        }

        this.removeDrugstoresFromOrderWithWarning(event.items)
      }

    },

    removeDrugstoresFromOrderWithWarning(drugstoreClientIdsToRemove) {
      if (this.orderDrugstoresCurrent.length === 1) {
        return Swal.fire({
          title: "Uwaga",
          text: "Nie możesz usunąć ostatniej apteki z zamówienia, spowoduje to usunięcie całego zamówienia. Musisz dodać nową aptekę przed usunięciem wybranej.",
          icon: "warning",
          customClass: {
            container: "swal-highest"
          },
        })
      }

      return Swal.fire({
        title: "Uwaga",
        text: "Czy na pewno chcesz usunąć aptekę? Wszystkie wprowadzone przez Ciebie zmiany dotyczące tej apteki zostaną utracone.",
        showCloseButton: true,
        showConfirmButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#556ee6",
        confirmButtonText: 'Tak, usuń aptekę',
        cancelButtonText: 'Nie',
        customClass: {
          container: "swal-highest"
        },

      }).then((proceed) => {
        if (proceed.isConfirmed) {
          this.removeDrugstoresFromOrder(drugstoreClientIdsToRemove)
        }
      });
    },

    ignoreItems() {
      const payload = {
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        ignoredChangeRequest: {
          itemsGuids: this.selectedItemsGuids,
          ignored: true
        }
      }
      if (this.groupViewMode) {
        this.packagesModule.httpUpdateAllGroupItemsIgnoredInOrder(payload).then(() => {
          this.refreshItemsData("ignoreItems httpUpdateAllGroupItemsIgnoredInOrder");
        })
      } else {
        this.packagesModule.httpChangePackageItemIgnoredStatus(payload.ignoredChangeRequest).then(() => {
          this.refreshItemsData("ignoreItems httpChangePackageItemIgnoredStatus");
        })
      }


    },


    unIgnoreItems() {
      const payload = {
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        ignoredChangeRequest: {
          itemsGuids: this.selectedItemsGuids,
          ignored: false
        }
      }
      if (this.groupViewMode) {
        this.packagesModule.httpUpdateAllGroupItemsIgnoredInOrder(payload).then(() => {
          this.refreshItemsData("unIgnoreItems httpUpdateAllGroupItemsIgnoredInOrder");
        })
      } else {
        this.packagesModule.httpChangePackageItemIgnoredStatus(payload.ignoredChangeRequest).then(() => {
          this.refreshItemsData("unIgnoreItems httpChangePackageItemIgnoredStatus");
        })
      }

    },

    addNotificationsToItemsWithWarning() {
      // create Swall dialog with textarea input
      Swal.fire({
        title: "Dodaj uwagi do towarów",
        input: 'textarea',
        inputPlaceholder: 'Wprowadź uwagi do towarów, które chcesz dodać',
        showCancelButton: true,
        confirmButtonText: 'Dodaj uwagi',
        cancelButtonText: 'Anuluj',
        customClass: {
          container: "swal-highest"
        },
      }).then((result) => {
            if (result.isConfirmed) {
              const newNotification = result.value;
              if (!newNotification || newNotification.trim() === "") {
                Swal.fire({
                  title: "Błąd",
                  text: "Nie wprowadzono żadnych uwag do towarów.",
                  icon: "error",
                  customClass: {
                    container: "swal-highest"
                  },
                })
                return;
              }
              this.addNotificationsToItems(newNotification, false);
            }
          }
      )


    },

    addNotificationsToItems(notifications) {

      const payload = {
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        notificationsRequest: {
          itemsGuids: this.selectedItemsGuids,
          notification: notifications,
          override: false,
        }
      }

      if (this.groupViewMode) {
        this.lazyloaderModule.setDisplayLazyLoader(true);
        this.packagesModule.httpAddNotificationsToGroupItems(payload).then(() => {
          this.selectedItemsGuids = [];
          this.showMassGeneratorTableActions = false;
          this.refreshItemsData("addNotificationsToItems httpAddNotificationsToGroupItems");
          this.lazyloaderModule.setDisplayLazyLoader(false);
        })
      } else {
        this.lazyloaderModule.setDisplayLazyLoader(true);
        this.packagesModule.httpAddNotificationsToSingleItems(payload.notificationsRequest).then(() => {
          this.selectedItemsGuids = [];
          this.showMassGeneratorTableActions = false;
          this.refreshItemsData("addNotificationsToItems httpAddNotificationsToSingleItems");
          this.lazyloaderModule.setDisplayLazyLoader(false);
        })

      }


    },

    removeItemsFromOrderWithWarning() {
      if (this.isOrderPublished) {
        Swal.fire({
          title: "Zamówienie zostało opublikowanie",
          text: "Nie możesz usuwać towarów z opublikowanego już zamówienia.",
          icon: "warning",
          customClass: {
            container: "swal-highest"
          },
        })
        return;
      }


      return Swal.fire({
        title: "Uwaga",
        text: "Czy na pewno chcesz usunąć towar? Wszystkie wprowadzone przez Ciebie zmiany dotyczące tego towaru zostaną utracone.",
        showCloseButton: true,
        showConfirmButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#556ee6",
        confirmButtonText: 'Tak, usuń towar',
        cancelButtonText: 'Nie',
        customClass: {
          container: "swal-highest"
        },

      }).then((proceed) => {
        if (proceed.isConfirmed) {

          this.removeItemsFromOrder(this.selectedItemsGuids).then(() => {
            this.refreshItemsData("removeItemsFromOrderWithWarning");
          })


        }
      });
    },

    roundAmountValue(newValue) {
      // round half up newValue
      // const roundNewValue = Math.round((parseFloat(newValue) + Number.EPSILON) * 100) / 100;
      // if rest is exactly = .5 than round up
      var amount = 0.0
      if (parseFloat(newValue) % 1 === 0.5) {
        amount = Math.ceil(newValue)
      } else {
        amount = Math.round(newValue)
      }
      return amount
    },
   calculateOfferPriceAfterDiscount(offerPrice, percentageDiscountSum,quotaDiscountSum) {
      if(quotaDiscountSum == null || quotaDiscountSum === 0){
        return offerPrice - (offerPrice * percentageDiscountSum / 100);
      }else{
        return offerPrice - (offerPrice * ((percentageDiscountSum / 100.0) + (quotaDiscountSum / offerPrice)) );
      }

    },

    setNewLogisticValueOnAmountFocusedCell(newValue) {
      // Temporarily disabled - no use for that feature now
      console.log("setNewLogisticValueOnAmountFocusedCell newValue:", newValue);
    },

    setLogisticValueForAllWithWarning(option, toAll) {
      // Show confirmation with required radio choice for calculation mode
      packagesHelperMethods.displayAmountSetterWarningDialog(option).then((result) => {
        if (result.isConfirmed) {
          const calcMode = result.value;

          if (toAll) {
            if (this.groupViewMode) {
              console.log("Group view mode - setting value for all drugstores and products")
              this.setSelectedValueForAsAnAmountToAllGroupItems({option: option.key, calculationMode: calcMode});
            } else {
              console.log("Normal view mode - setting value for all items")
              this.setSelectedValueForAsAnAmountToAllItems({option: option.key, calculationMode: calcMode})
            }
            return;
          }

          if (this.groupViewMode) {
            console.log("Group view mode - setting value for all drugstores and products")
            this.setSelectedValueForAsAnAmountToSelectedGroupItems({option: option.key, calculationMode: calcMode});
          } else {
            console.log("Normal view mode - setting value for selected items only")
            this.setSelectedValueForAsAnAmountToSelectedItems({option: option.key, calculationMode: calcMode})
          }

        }
      });
    },

    getCalculatedItemValue(itemRecord) {
      var offerPrice = 0.0;
      if (itemRecord.offerPrice != null) {
        offerPrice = parseFloat(itemRecord.offerPrice);
      }

      var itemAmount = 0;
      if (itemRecord.amount != null) {
        itemAmount = parseFloat(itemRecord.amount);
      }

      var sellingTax = 0.0;
      if (itemRecord.sellingTax != null) {
        sellingTax = parseFloat(itemRecord.sellingTax);
      }
      var calculatedDiscountPercentage = 0.0;
      if (itemRecord.calculatedDiscountPercentage != null) {
        calculatedDiscountPercentage = parseFloat(itemRecord.calculatedDiscountPercentage);
      }

      var calculatedDiscountQuota = 0.0;
      if (itemRecord.calculatedDiscountQuota != null) {
        calculatedDiscountQuota = parseFloat(itemRecord.calculatedDiscountQuota);
      }

      const offerPriceAfterDiscount = this.calculateOfferPriceAfterDiscount(offerPrice, calculatedDiscountPercentage,calculatedDiscountQuota);
      const result = {
        itemOrderedValueTaxExcl: (offerPrice * itemAmount).toFixed(2),
        itemOrderedValueTaxIncl: (offerPrice * itemAmount * (1 + sellingTax / 100)).toFixed(2),
        itemOrderedValueTaxExclAfterDiscount: (offerPriceAfterDiscount * itemAmount).toFixed(2),
        itemOrderedValueTaxInclAfterDiscount: (offerPriceAfterDiscount * itemAmount * (1 + sellingTax / 100)).toFixed(2)
      }


      return result;
    },

    calculateItemOrderedValueTaxExcl(itemRecord){
      var offerPrice = 0.0;
      if (itemRecord.offerPrice != null) {
        offerPrice = parseFloat(itemRecord.offerPrice);
      }

      var itemAmount = 0;
      if (itemRecord.amount != null) {
        itemAmount = parseFloat(itemRecord.amount);
      }

      return (offerPrice * itemAmount).toFixed(2);
    },

    calculateItemOrderedValueTaxIncl(itemRecord){
      var offerPrice = 0.0;
      if (itemRecord.offerPrice != null) {
        offerPrice = parseFloat(itemRecord.offerPrice);
      }

      var itemAmount = 0;
      if (itemRecord.amount != null) {
        itemAmount = parseFloat(itemRecord.amount);
      }

      var sellingTax = 0.0;
      if (itemRecord.sellingTax != null) {
        sellingTax = parseFloat(itemRecord.sellingTax);
      }

      return (offerPrice * itemAmount * (1 + sellingTax / 100)).toFixed(2);
    },

    calculateItemOrderedValueTaxExclAfterDiscount(itemRecord){
      var offerPrice = 0.0;
      if (itemRecord.offerPrice != null) {
        offerPrice = parseFloat(itemRecord.offerPrice);
      }

      var itemAmount = 0;
      if (itemRecord.amount != null) {
        itemAmount = parseFloat(itemRecord.amount);
      }

      var calculatedDiscountPercentage = 0.0;
      if (itemRecord.calculatedDiscountPercentage != null) {
        calculatedDiscountPercentage = parseFloat(itemRecord.calculatedDiscountPercentage);
      }

      var calculatedDiscountQuota = 0.0;
      if (itemRecord.calculatedDiscountQuota != null) {
        calculatedDiscountQuota = parseFloat(itemRecord.calculatedDiscountQuota);
      }

      const offerPriceAfterDiscount = this.calculateOfferPriceAfterDiscount(offerPrice, calculatedDiscountPercentage,calculatedDiscountQuota);
      return (offerPriceAfterDiscount * itemAmount).toFixed(2)
    },

    calculateItemOrderedValueTaxInclAfterDiscount(itemRecord){
      var offerPrice = 0.0;
      if (itemRecord.offerPrice != null) {
        offerPrice = parseFloat(itemRecord.offerPrice);
      }

      var itemAmount = 0;
      if (itemRecord.amount != null) {
        itemAmount = parseFloat(itemRecord.amount);
      }

      var sellingTax = 0.0;
      if (itemRecord.sellingTax != null) {
        sellingTax = parseFloat(itemRecord.sellingTax);
      }
      var calculatedDiscountPercentage = 0.0;
      if (itemRecord.calculatedDiscountPercentage != null) {
        calculatedDiscountPercentage = parseFloat(itemRecord.calculatedDiscountPercentage);
      }
      var calculatedDiscountQuota = 0.0;
      if (itemRecord.calculatedDiscountQuota != null) {
        calculatedDiscountQuota = parseFloat(itemRecord.calculatedDiscountQuota);
      }


      const offerPriceAfterDiscount = this.calculateOfferPriceAfterDiscount(offerPrice, calculatedDiscountPercentage,calculatedDiscountQuota);
      return (offerPriceAfterDiscount * itemAmount * (1 + sellingTax / 100)).toFixed(2);
    },

    getSumItemPercentageDiscount(itemRecord) {
      var discountSum = 0.0;
      this.packageDiscounts.forEach((discount) => {
        if (discount.discountKey.startsWith("packageDiscount_") && discount.type === "PERCENT") {
          var discountVal = itemRecord[discount.discountKey]
          if (!discountVal) {
            discountVal = 0.0;
          }
          discountSum += parseFloat(discountVal);
        }
      });


      return discountSum.toFixed(2);

    },

    getSumItemQuotaDiscount(itemRecord) {
      var discountSum = 0.0;
      this.packageDiscounts.forEach((discount) => {
        if (discount.discountKey.startsWith("packageDiscount_") && discount.type === "QUOTA") {
          var discountVal = itemRecord[discount.discountKey]
          if (!discountVal) {
            discountVal = 0.0;
          }
          discountSum += parseFloat(discountVal);
        }
      });

      return discountSum.toFixed(2);

    },

    getDiscountsSumsWithType(itemRecord) {
      var percentageDiscountSum = 0.0;
      var quotaDiscountSum = 0.0;
      this.packageDiscounts.forEach((discount) => {
        if (discount.discountKey.startsWith("packageDiscount_")) {
          var discountVal = itemRecord[discount.discountKey]
          if (!discountVal) {
            discountVal = 0.0;
          }
          console.log("Adding discounts:", discount)
          if(discount.type === "PERCENT"){
            percentageDiscountSum += parseFloat(discountVal);
          }else{
            quotaDiscountSum += parseFloat(discountVal);
          }

        }
      });

      return {percentageDiscountSum: percentageDiscountSum.toFixed(2), quotaDiscountSum: quotaDiscountSum.toFixed(2)};

    },

    setSelectedValueForAsAnAmountToSelectedGroupItems(input) {
      const valueKey = input.option
      const calculationMode = input.calculationMode

      const payload = {
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        valueKey: valueKey,
        itemsGroupGuids: this.selectedItemsGuids,
        calculationMode: calculationMode ? calculationMode : "STATE_MINUS_PACKAGE_STOCK"
      }

      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.isLoading = true;
      this.packagesModule.httpCalculateAmountForGroupItemsInOrder(payload).then(() => {
        this.refreshItemsData("setSelectedValueForAsAnAmountToSelectedGroupItems");
        this.lazyloaderModule.setDisplayLazyLoader(false);
        this.isLoading = false;
      })


    },

    setSelectedValueForAsAnAmountToAllGroupItems(input) {
      const valueKey = input.option
      const calculationMode = input.calculationMode

      const payload = {
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        valueKey: valueKey,
        calculationMode: calculationMode ? calculationMode : "STATE_MINUS_PACKAGE_STOCK"
      }

      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.isLoading = true;
      this.packagesModule.httpCalculateAmountForAllGroupItemsInOrder(payload).then(() => {
        this.refreshItemsData("setSelectedValueForAsAnAmountToAllGroupItems");
        this.lazyloaderModule.setDisplayLazyLoader(false);
        this.isLoading = false;
      })


    },


    setSelectedValueForAsAnAmountToSelectedItems(input) {
      const valueKey = input.option
      const calculationMode = input.calculationMode

      const payload = {
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        valueKey: valueKey,
        itemsGuids: this.selectedItemsGuids,
        calculationMode: calculationMode ? calculationMode : "STATE_MINUS_PACKAGE_STOCK"
      }

      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.isLoading = true;
      this.packagesModule.httpCalculateAmountForSingleItemsInOrder(payload).then(() => {
        this.refreshItemsData("setSelectedValueForAsAnAmountToSelectedItems");
        this.lazyloaderModule.setDisplayLazyLoader(false);
        this.isLoading = false;
      })


    },

    setSelectedValueForAsAnAmountToAllItems(input) {
      const valueKey = input.option
      const calculationMode = input.calculationMode

      const payload = {
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        valueKey: valueKey,
        calculationMode: calculationMode ? calculationMode : "STATE_MINUS_PACKAGE_STOCK"
      }

      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.isLoading = true;
      this.packagesModule.httpCalculateAmountForAllSingleItemsInOrder(payload).then(() => {
        this.refreshItemsData("setSelectedValueForAsAnAmountToAllItems");
        this.lazyloaderModule.setDisplayLazyLoader(false);
        this.isLoading = false;
      })


    },

    setCellValue(row, column, value) {
      this.focusCell(row, column)
      this.$refs.packagesOrderPreparedExcelView.$refs.excelEditor.setCellValue(row, column, value);
    },

    setCellValueWithoutEmit(row, column, value) {
      this.focusCell(row, column)
      this.$refs.packagesOrderPreparedExcelView.$refs.excelEditor.setCellValueWithoutEmit(row, column, value);
    },

    setColumnValue(column, value, filterInPayload) {
      this.$refs.packagesOrderPreparedExcelView.$refs.excelEditor.setColumnValue(column, value, filterInPayload);
    },

    setColumnCalcValue(column, calcFunction, filterInPayload) {
      this.$refs.packagesOrderPreparedExcelView.$refs.excelEditor.setColumnCalcValue(column, calcFunction, filterInPayload);
    },

    focusCell(row, column) {
      this.$refs.packagesOrderPreparedExcelView.$refs.excelEditor.focusCell(row, column); // Ustawia fokus na komórce w 3. wierszu i 4. kolumnie (indeksy od 0)
    },

    onCellClick(event) {
      this.currentFocusedCell = event
      if (this.isLogisticContainerOpen) {
        this.fetchLogisticDetails(event)
      }
    },

    onCellDbClick(event) {
      if (this.groupViewMode) return;

      if (event.field.name.startsWith("soldFrom")) { // meanest that user db clikcked on th selling range cell
        var amountFromSoldValue = event.value ? parseFloat(event.value) : 0.0;

        const logisticMinPerDrugstore = event.record['logisticMinAmountPerDrugstore'] ? parseFloat(event.record['logisticMinAmountPerDrugstore']) : 0.0;
        if (amountFromSoldValue < logisticMinPerDrugstore) {
          amountFromSoldValue = logisticMinPerDrugstore
        }

        amountFromSoldValue = this.roundAmountValue(amountFromSoldValue)
        event.record['amount'] = amountFromSoldValue; // set amount on record reference emitted by excel editor

        const cellUpdateEventPayload = {
          colKey: 'amount',
          row: event.record,
          newVal: amountFromSoldValue

        }
        // triggering onCellUpdate to update the itemValueTaxExcl and valueTaxIncl columns and send update to backend
        this.onCellUpdate(cellUpdateEventPayload)
      }

    },

    fetchLogisticDetails(event) {

      const rowPos = event.rowPos
      const colPos = event.colPos
      const selectedColKey = this.visibleHeaderKeys[colPos];
      console.log("fetchLogisticDetails colKey:", selectedColKey)

      const rowProductData = this.orderGeneratorTableData[rowPos]
      if (this.selectedProductData && this.selectedProductData.centralProductGuid === rowProductData['centralProductGuid']) {
        // already selected/data fetched no need to fetch again from API
        return;
      }
      var drugstoresClientIds = []

      if(selectedColKey.endsWith("_CalculatedDemand")){
        // split key and get first element (drugstore client id)
        const drugstoreClientId = selectedColKey.split("_")[0];
        drugstoresClientIds.push(drugstoreClientId)
      }
      drugstoresClientIds = this.groupViewMode === true ? drugstoresClientIds : [rowProductData['drugstoreClientId']]
      this.refreshProductLogisticDetailsDataForDrugstores(rowProductData['centralProductGuid'], drugstoresClientIds, rowProductData['groupGuid'])
    },
    onFirstRowReached(event) {
     // scroll to absolute window top
      console.log("onFirstRowReached")
      this.$refs.packagesOrderPreparedExcelView.$refs.tableScroll.scrollTo({
        top:0
      });

      this.$refs.generatorTableSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    },
    onLastRowReached(event) {
      // scroll to absolute window bottom
      console.log("onLastRowReached")
      const el = this.$refs.packagesOrderPreparedExcelView.$refs.tableScroll;


      el.scrollTo({
        top: el.scrollHeight
      });

    },

    onCellUpdate(event) {
      console.log("Event to save")
      console.log(event)
      const tableRowDataObject = event.row
      const colKey = event.colKey
      const newValue = event.newVal
      const itemGroupGuid = tableRowDataObject['groupGuid'];
      const drugstoreClientId = tableRowDataObject['drugstoreClientId'];
      const itemGuid = tableRowDataObject['guid'];
      const orderGroupGuid = this.currentGroupOrder.groupGuid;

      if (colKey.startsWith("packageDiscount_")) {
        const packageDiscountColIndex = this.availableHeaders.findIndex(header => header.key === colKey);
        const calculatedDiscountPercentageColIndex = this.availableHeaders.findIndex(header => header.key === 'calculatedDiscountPercentage');
        const calculatedDiscountQuotaColIndex = this.availableHeaders.findIndex(header => header.key === 'calculatedDiscountQuota');
        const discountColIndex = this.availableHeaders.findIndex(header => header.key === 'discount');
        const packageDiscount = this.packageDiscounts.find(discount => discount.discountKey === colKey);
        var discountValue = 0.0;
        if(newValue){
          discountValue = parseFloat(newValue);
        }

        if (packageDiscount) {
          if (packageDiscount.separateForEveryOrderItem) {
            const discountSum = this.getDiscountsSumsWithType(tableRowDataObject);
            const percentageDiscountSum = discountSum.percentageDiscountSum;
            const quotaDiscountSum = discountSum.quotaDiscountSum;
            tableRowDataObject['calculatedDiscountQuota'] = quotaDiscountSum;
            tableRowDataObject['calculatedDiscountPercentage'] = percentageDiscountSum;
            tableRowDataObject['discount'] = percentageDiscountSum;
            const updatePayload = {
              discountGuid: packageDiscount.guid,
              refGuid: itemGroupGuid,
              value: discountValue
            }
            // no need to handle groupViewMode because item level discount should be always the same for every item in the group
            this.packagesModule.httpUpdatePackageDiscountValue(updatePayload);
            this.setColumnCalcValue(calculatedDiscountQuotaColIndex, this.getSumItemQuotaDiscount, {"groupGuid": itemGroupGuid})
            this.setColumnValue(packageDiscountColIndex, discountValue, {"groupGuid": itemGroupGuid});
            this.setColumnCalcValue(calculatedDiscountPercentageColIndex, this.getSumItemPercentageDiscount, {"groupGuid": itemGroupGuid})
            this.setColumnCalcValue(discountColIndex, this.getSumItemPercentageDiscount, {"groupGuid": itemGroupGuid})
            this.updateItemDiscountedValues(orderGroupGuid,itemGroupGuid, percentageDiscountSum,quotaDiscountSum, tableRowDataObject.offerPrice != null ? parseFloat(tableRowDataObject.offerPrice) : 0.0);
            // waint for 500 millis to update the discounted values
            setTimeout(() => {
              this.updateGroupItemsSummaryAfterDiscountColumns(itemGroupGuid);
            }, 500);


          } else {
            const discountSum = this.getDiscountsSumsWithType(tableRowDataObject);
            const percentageDiscountSum = discountSum.percentageDiscountSum;
            const quotaDiscountSum = discountSum.quotaDiscountSum;
            tableRowDataObject['calculatedDiscountQuota'] = quotaDiscountSum;
            tableRowDataObject['calculatedDiscountPercentage'] = percentageDiscountSum;
            tableRowDataObject['discount'] = percentageDiscountSum;
            // no need to handle groupViewMode because package order level discount is applied to all items in group order
            const updatePayload = {
              discountGuid: packageDiscount.guid,
              refGuid: orderGroupGuid,
              value: newValue
            }
            this.packagesModule.httpUpdatePackageDiscountValue(updatePayload);
            // update all cells in column with discount value (without emit to prevent recursion
            this.setColumnValue(packageDiscountColIndex, newValue, {});
            this.setColumnCalcValue(calculatedDiscountQuotaColIndex, this.getSumItemQuotaDiscount, {})
            this.setColumnCalcValue(calculatedDiscountPercentageColIndex, this.getSumItemPercentageDiscount, {})
            this.setColumnCalcValue(discountColIndex, this.getSumItemPercentageDiscount, {})
            this.updateGroupItemsSummaryAfterDiscountColumns(null); // update all records summaries
            // TODO: koniecznie zamienić tą metodę na taką która updatuje rabat na wszytskich Itemach dla zadanego groupOrderGuid
            // TODO gdyz w tym przypadku zmienimay wartosc rabatu dla wszytskich pozycji w zamówieniu
            // update calculatedDiscountPercentage and discount values on backend
            this.updateItemDiscountedValues(orderGroupGuid,itemGroupGuid, percentageDiscountSum,quotaDiscountSum, tableRowDataObject.offerPrice != null ? parseFloat(tableRowDataObject.offerPrice) : 0.0);
          }

        }

      }
      if (colKey === 'logisticMinAmountPerOrder') {
        const logisticMinAmountPerOrderColIndex = this.availableHeaders.findIndex(header => header.key === colKey);
        const roundNewValue = this.roundAmountValue(newValue)
        tableRowDataObject['logisticMinAmountPerOrder'] = roundNewValue
        const updatePayload = {
          itemGroupGuid: itemGroupGuid,
          orderGroupGuid: orderGroupGuid,
          value: roundNewValue
        }
        // no need to handle groupViewMode because item level discount should be always the same for every item in the group
        this.packagesModule.httpUpdateLogisticMinPerOrderValue(updatePayload);
        this.setColumnValue(logisticMinAmountPerOrderColIndex, roundNewValue, {"groupGuid": itemGroupGuid});

      } else if (colKey === 'logisticMinAmountPerDrugstore') {
        const logisticMinAmountPerDrugstoreColIndex = this.availableHeaders.findIndex(header => header.key === colKey);
        const amountColIndex = this.availableHeaders.findIndex(header => header.key === 'amount');
        const roundNewValue = this.roundAmountValue(newValue)
        tableRowDataObject['logisticMinAmountPerDrugstore'] = roundNewValue
        const updatePayload = {
          itemGroupGuid: itemGroupGuid,
          orderGroupGuid: orderGroupGuid,
          value: roundNewValue
        }


        this.packagesModule.httpUpdateLogisticMinPerDrugstoreValue(updatePayload);
        this.setColumnValue(logisticMinAmountPerDrugstoreColIndex, roundNewValue, {
          "groupGuid": itemGroupGuid
        });
        var currentAmount = tableRowDataObject['amount'] ? parseFloat(tableRowDataObject['amount']) : 0.0;
        var logisticMinVal = roundNewValue ? parseFloat(roundNewValue) : 0.0;
        if (logisticMinVal > currentAmount) {
          console.log("Setting new logistic min amount to current amount : ", amountColIndex, logisticMinVal)
          this.$refs.mainAlert.showWarning(
              'Uwaga',
              'Ilość mniejsza niż minimum logistyczne - dostosowuję ilość',
              3000
          );

          this.setColumnValue(amountColIndex, logisticMinVal, {
            "groupGuid": itemGroupGuid
          });
          this.updateGroupItemsSummaryColumns(itemGroupGuid);

        }

      } else if (colKey === 'offerPrice') {
        var calculatedDiscountPercentage = 0.0;

        if(tableRowDataObject['calculatedDiscountPercentage'] != null){
          calculatedDiscountPercentage = parseFloat(tableRowDataObject['calculatedDiscountPercentage'])
        }
        var calculatedDiscountQuota = 0.0;
        if(tableRowDataObject['calculatedDiscountQuota'] != null){
          calculatedDiscountQuota = parseFloat(tableRowDataObject['calculatedDiscountQuota'])
        }

        const payload = {
          orderGroupGuid: this.currentGroupOrder.groupGuid,
          priceRequest: {
            price: newValue,
            offerPriceAfterDiscount: this.calculateOfferPriceAfterDiscount(newValue,calculatedDiscountPercentage,calculatedDiscountQuota),
            itemsGuids: [itemGroupGuid],
          }
        }
        // offer price update always for all items in group
        this.packagesModule.httpUpdateOfferPriceCalculatedInGroupItemsByGroupItemsGuids(payload,false)


        const offerPriceColIndex = this.availableHeaders.findIndex(header => header.key === 'offerPrice');
        this.setColumnValue(offerPriceColIndex, newValue, {
          "groupGuid": itemGroupGuid
        });

       this.updateGroupItemsSummaryColumns(itemGroupGuid);

      } else if (colKey === 'amount') {
        // no need to handle groupViewMode because amount is different for every item in group order, we don`t need to update amount by group
        var amount = this.roundAmountValue(newValue)
        tableRowDataObject['amount'] = amount
        const logisticMinPerDrugstore = tableRowDataObject['logisticMinAmountPerDrugstore'] ? parseFloat(tableRowDataObject['logisticMinAmountPerDrugstore']) : 0.0;
        if (newValue < logisticMinPerDrugstore) {
          this.$refs.mainAlert.showWarning(
              'Uwaga',
              'Ilość mniejsza niż minimum logistyczne - dostosowuję ilość',
              3000
          );
          amount = logisticMinPerDrugstore

        }

        const payload = {
          orderGroupGuid: this.currentGroupOrder.groupGuid,
          amountRequest: {
            amount: amount,
            itemsGuids: [itemGuid],
          }
        }
        const currentCellRowPos = this.orderGeneratorTableData.findIndex(row => row.guid === itemGuid);
        const currentCellColPos = this.availableHeaders.findIndex(header => header.key === colKey);

        this.packagesModule.httpUpdateAmountInSingleItemsByItemsGuids(payload.amountRequest, false).then(() => {
          console.log("Amount updated, setting row value", currentCellRowPos, currentCellColPos, amount)

          tableRowDataObject['amount'] = amount;
        })

        this.updateGroupItemsSummaryColumns(itemGroupGuid)

      } else if (colKey === 'notifications') {
        const newNotification = newValue;

        const payload = {
          orderGroupGuid: this.currentGroupOrder.groupGuid,
          notificationsRequest: {
            itemsGuids: this.groupViewMode === true ? [itemGroupGuid] : [itemGuid],
            notification: newNotification,
            override: false,
          }
        }
        if (this.groupViewMode) {
          this.packagesModule.httpAddNotificationsToGroupItems(payload, false)
        } else {
          this.packagesModule.httpAddNotificationsToSingleItems(payload.notificationsRequest, false)

        }
      } else if (colKey.includes("CalculatedDemand")) {
        var payload = {};
        // means that focused cell is a drugstore column
        const colHeaderSplit = colKey.split("_")
        if (colHeaderSplit.length < 3) {
          // means that selected col is not a drugstore column, but something else, unhandled
          return;
        }


        payload['itemGroupGuid'] = itemGroupGuid
        payload['orderGroupGuid'] = orderGroupGuid
        payload['drugstoreClientId'] = colHeaderSplit[0]

        var newAmountForDrugstore = this.roundAmountValue(newValue)
        const logisticMinPerDrugstore = tableRowDataObject['logisticMinAmountPerDrugstore'] ? parseFloat(tableRowDataObject['logisticMinAmountPerDrugstore']) : 0.0;
        if (newAmountForDrugstore < logisticMinPerDrugstore) {
          newAmountForDrugstore = logisticMinPerDrugstore
          this.$refs.mainAlert.showWarning(
              'Uwaga',
              'Ilość mniejsza niż minimum logistyczne - dostosowuję ilość',
              3000
          );

        }

        payload['amount'] = this.roundAmountValue(newAmountForDrugstore)
        this.packagesModule.httpUpdateSingleItemAmountByItemGroupGuidAndDrugstoreClientId(payload).then(() => {

          tableRowDataObject[colKey] = newAmountForDrugstore;
          const oldValue = parseFloat(event.oldVal)
          const oldSumAmountValue = parseFloat(tableRowDataObject['amount'])
          tableRowDataObject['amount'] = (oldSumAmountValue - oldValue) + newAmountForDrugstore;
          this.updateGroupItemsSummaryColumns(itemGroupGuid)

        })


      }
    },

    updateGroupItemsSummaryColumns(itemGroupGuid){
     this.updateGroupItemsSummaryBeforeDiscountColumns(itemGroupGuid);
     this.updateGroupItemsSummaryAfterDiscountColumns(itemGroupGuid);
    },
    updateGroupItemsSummaryBeforeDiscountColumns(itemGroupGuid){
      const itemOrderedValueTaxExclColIndex = this.availableHeaders.findIndex(header => header.key === 'itemOrderedValueTaxExcl');
      const itemOrderedValueTaxInclColIndex = this.availableHeaders.findIndex(header => header.key === 'itemOrderedValueTaxIncl');
      this.setColumnCalcValue(itemOrderedValueTaxExclColIndex, this.calculateItemOrderedValueTaxExcl, {"groupGuid": itemGroupGuid});
      this.setColumnCalcValue(itemOrderedValueTaxInclColIndex,  this.calculateItemOrderedValueTaxIncl, {"groupGuid": itemGroupGuid});
    },
    updateGroupItemsSummaryAfterDiscountColumns(itemGroupGuid){
      var filterPayload = {};
      if(itemGroupGuid){
        filterPayload = {"groupGuid": itemGroupGuid}
      }

      const itemOrderedValueTaxExclAfterDiscountColIndex = this.availableHeaders.findIndex(header => header.key === 'itemOrderedValueTaxExclAfterDiscount');
      const itemOrderedValueTaxInclAfterDiscountColIndex = this.availableHeaders.findIndex(header => header.key === 'itemOrderedValueTaxInclAfterDiscount');
      this.setColumnCalcValue(itemOrderedValueTaxExclAfterDiscountColIndex, this.calculateItemOrderedValueTaxExclAfterDiscount, filterPayload);
      this.setColumnCalcValue(itemOrderedValueTaxInclAfterDiscountColIndex, this.calculateItemOrderedValueTaxInclAfterDiscount, filterPayload);

    },

    updateItemDiscountedValues(orderGroupGuid, itemGroupGuid, percentageDiscountSum,quotaDiscountSum, offerPrice){
      // update calculatedDiscountPercentage and discount values on backend
      const payload = {
        orderGroupGuid: orderGroupGuid,
        discountRequest: {
          percentageDiscountSum: percentageDiscountSum,
          quotaDiscountSum: quotaDiscountSum,
          offerPriceAfterDiscount: this.calculateOfferPriceAfterDiscount(offerPrice, percentageDiscountSum,quotaDiscountSum),
          itemsGuids: [itemGroupGuid],
        }
      }
      // no need to handle groupViewMode because item level discount should be always the same for every item in the group
      this.packagesModule.httpUpdateDiscountCalculatedInGroupItemsByGroupItemsGiuds(payload,false)

    },

    onCellFocus(event) {
      log.log("onCellFocus event:")
      log.log(event)
      this.currentFocusedCell = event
      if (event.rowPos === 0) {
        this.scrollToTop();
      } else if (event.rowPos === 49) {
        this.scrollToDown()
      } else {
        event.cell.scrollIntoView({behavior: 'smooth', block: 'nearest'});
      }

    },

    scrollToTop() {
      const el = this.$refs.generatorTableView;
      if (!el) return;
      el.scrollTo({top: 0, behavior: 'smooth'});
    },
    scrollToDown() {
      const el = this.$refs.generatorTableView;
      if (!el) return;
      console.log("Scrolling to bottom of table")
      console.log(el)
      el.scrollTo({top: 500, behavior: 'smooth'});
    },
    onCellBlur(event) {
      log.log("onCellBlur event:")
      log.log(event)
    },


    onPageChanged(event) {
      log.log("onPageChanged event:")
      log.log(event)
    },
    onSelectRow(event) {
      console.log("onSelectRow event:")
      console.log(event)
      if (event == null || event.allSelected == null) {
        this.selectedItemsGuids = []
        return;
      }

      const currentSelectedItemGuids = []
      var currentSelectedDrugstoresClientsIds = []
      for (let i = 0; i < event.allSelected.length; i++) {
        const rowProductData = this.orderGeneratorTableData[event.allSelected[i]];

        if (this.groupViewMode) {
          let rowProductGuid = rowProductData['groupGuid'];
          if (rowProductGuid && !currentSelectedItemGuids.includes(rowProductGuid)) {
            currentSelectedItemGuids.push(rowProductGuid)
          }


        } else {
          let rowProductGuid = rowProductData['guid'];
          if (rowProductGuid && !currentSelectedItemGuids.includes(rowProductGuid)) {
            currentSelectedItemGuids.push(rowProductGuid)
          }
          let rowDrugstoreClientId = rowProductData['drugstoreClientId'];
          if (rowDrugstoreClientId && !currentSelectedDrugstoresClientsIds.includes(rowDrugstoreClientId)) {
            currentSelectedDrugstoresClientsIds.push(rowDrugstoreClientId)
          }
        }


      }

      this.selectedItemsGuids = currentSelectedItemGuids

      console.log("After SELECTING/UNSELECTING, selectedItemsGuids:")
      console.log(this.selectedItemsGuids)
      this.toggleMassGeneratorTableActions()

      if (event.allSelected.length === 1) {
        const rowPos = event.allSelected[0]
        const rowProductData = this.orderGeneratorTableData[rowPos]
        // only allowing to get logistic data for one product at once
        if (this.isLogisticContainerOpen) {
          this.refreshProductLogisticDetailsDataForDrugstores(rowProductData['centralProductGuid'], currentSelectedDrugstoresClientsIds, rowProductData['groupGuid'])
        }

      }


    },

    onMassClearSelect() {
      this.selectedItemsGuids = []
      this.toggleMassGeneratorTableActions()
    },
    toggleMassGeneratorTableActions() {
      if (!this.showMassGeneratorTableActions && this.selectedItemsGuids.length > 0) {
        this.showMassGeneratorTableActions = true;
      } else if (this.showMassGeneratorTableActions && this.selectedItemsGuids.length === 0) {
        this.showMassGeneratorTableActions = false;
      }

    },
    async onSort(event) {
      log.log("onSort event:")
      log.log(event);
      this.sortingKey = event.colKey;
      // find header obj in availableHeaders array by sorting key
      const header = this.availableHeaders.find(header => header.key === this.sortingKey);
      if (header.sortable === false) return;

      log.log(this.sortingKey);
      this.toggleSortingDirection();
      await this.saveSortingSetting(this.sortingKey, this.sortingDirection);
      await this.refreshItemsData("onSort");
    },


    exportAndSendEmailToDrugstores() {
      packagesHelperMethods.exportGroupOrderToFile(this.currentGroupOrder, "XLS", true, false).then((response) => {
        log.log(response);
        if (response.isConfirmed) {
          this.mailContent = {
            sendMailDialogTitle: response.sendMailDialogTitle,
            mailMessage: response.mailMessage,
            mailSubject: response.mailSubject,
            mailTo: response.mailTo,
            mailCc: response.mailCc,
            mailAttachmentName: response.mailAttachmentName
          }

          this.packagesModule.httpGetGroupOrderEMailHistory({orderGroupGuid: this.currentGroupOrder.groupGuid}).then((response) => {
            if (response && response.data.payload.length > 0) {
              // get first of response.data.payload (ordered by send date)
              response.data.payload.sort((a, b) => new Date(b.sendDate) - new Date(a.sendDate));
              // getting last email
              const lastEmail = response.data.payload[0];

              this.showSendMailAlert = true;
              this.sendMailAlertType = "warning";
              this.sendMailAlertContent = "Wiadomość email z tym zamówieniem została już wysłana do aptek dnia " + packagesHelperMethods.formatDatetimeToLocaleFormat(lastEmail.sendDate);
            }

            this.showSendMailModal = true;
          })


        }
      });
    },
    refreshProductLogisticDetailsDataForDrugstores(centralProductGuid, drugstoresClientsIds, itemGroupGuid) {
      const payload = {
        centralProductGuid: centralProductGuid,
        drugstoresClientIds: drugstoresClientsIds,
        groupViewMode: this.groupViewMode,
        orderGroupGuid: this.currentGroupOrder.groupGuid
      }
      console.log("Refreshing logistic details for product with guid: ", payload)
      this.packagesModule.httpGetProductLogistics(payload).then((response) => {
        this.selectedProductData = JSON.parse(JSON.stringify(response.data.payload));
      })
      this.packagesModule.httpGetDrugstoresLogistics(payload).then((response) => {
        this.selectedDrugstoreData = JSON.parse(JSON.stringify(response.data.payload));
      })

      this.packagesModule.httpGetSellingLogistics(payload).then((response) => {
        this.selectedProductSelling = JSON.parse(JSON.stringify(response.data.payload));
      })

      this.packagesModule.httpGetSellingDetails(payload).then((response) => {
        this.selectedProductSellingDetails = JSON.parse(JSON.stringify(response.data.payload));
      })

      this.packagesModule.httpGetSuppliesLogistics(payload).then((response) => {
        this.selectedProductStock = JSON.parse(JSON.stringify(response.data.payload));
      })

      if (drugstoresClientsIds.length === 1) {

        this.packagesModule.httpGetSingleItemByItemGroupGuidAndDrugstore({
          orderGroupGuid: this.currentGroupOrder.groupGuid,
          itemGroupGuid: itemGroupGuid,
          drugstoreClientId: drugstoresClientsIds[0]
        }).then((response) => {
          this.selectedItemData = JSON.parse(JSON.stringify(response.data.payload));
        });
      } else {
        this.packagesModule.httpGetGroupItemBasicDataByItemGroupGuid({
          orderGroupGuid: this.currentGroupOrder.groupGuid,
          itemGroupGuid: itemGroupGuid
        }).then((response) => {
          this.selectedItemData = JSON.parse(JSON.stringify(response.data.payload));
        });
      }

      if (drugstoresClientsIds.length === 1) {
        this.packagesModule.httpGetLastStockDates({drugstoreClientId: drugstoresClientsIds[0]}).then((response) => {
          this.lastStockDates = JSON.parse(JSON.stringify(response.data.payload));
        });
      } else {

        this.packagesModule.httpGetLastStockDates({drugstoreClientId: null}).then((response) => {
          this.lastStockDates = JSON.parse(JSON.stringify(response.data.payload));
        });
      }


    },

    getAvailableFilters() {

    },

    updateFilters(filters) {
      this.selectedFilters = filters;
      // current page is watched and when it changes the refreshTable is triggered, so we have to refreshTable manually only if currentPage not chages
      if(this.currentPage === 0) {
        this.refreshItemsData("update filters");
      }else{
        this.currentPage = 0;
      }
    },
    toggleSortingDirection() {
      if (this.sortingDirection === "ASC") {
        this.sortingDirection = "DESC";
      } else {
        this.sortingDirection = "ASC";
      }
    },

    async refreshItemsData(source,afterSellingRangeAdded = false, afterDiscountAdded = false,afterDrugstoreAdded = false){
      console.log("Items refresh request::",source);
      this.isLoading = true;
      try {
        await this.fetchItemsData(source, afterSellingRangeAdded, afterDiscountAdded, afterDrugstoreAdded).then(() => {
          this.isLoading = false;
        })
      } catch (e) {
        console.log("Error while refreshing items data::", e);
      } finally {
        this.isLoading = false;
      }
    },

    async fetchItemsData(source,afterSellingRangeAdded = false, afterDiscountAdded = false,afterDrugstoreAdded = false) {
      this.searchAndFilterRequest = {
        fields: null,
        search: this.searchRequest,
        filters: this.selectedFilters
      }

      if (this.sortingKey === 'itemOrderedValueTaxIncl' || this.sortingKey === 'itemOrderedValueTaxExcl' || this.sortingKey === 'itemOrderedValueTaxInclAfterDiscount' || this.sortingKey === 'itemOrderedValueTaxExclAfterDiscount') {
        return;
      }

      if (this.sortingKey === 'drugstoreName') {
        // when sorting by drugstore name, we need to set sorting key to drugstoreClientId to have consistent sorting
        this.sortingKey = 'packageOrder.drugstore.name';
      }

      if (this.sortingKey === 'centralProductCartReference') {
        this.sortingKey = 'centralProduct.centralCartReference'
      }

      if (this.sortingKey === 'drugstoreCompanyName') {
        this.sortingKey = 'packageOrder.drugstore.companyName'
      }

      const payload = {
        searchAndFilterRequest: this.searchAndFilterRequest,
        currentPage: this.currentPage,
        sortingDirection: this.sortingDirection,
        sortingKey: this.sortingKey,
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        groupViewMode: this.groupViewMode,
        drugstoresInGridView: this.drugstoresInGridView,
      };

      console.log("Items payload",payload);

      this.orderGeneratorTableHeaders = []
      this.orderGeneratorTableData = [];
      const response = await this.packagesModule.httpGetAllGeneratorPackageItemsByOrderGroupGuidPaging(payload)

      console.log("Items response",response);

      var items = JSON.parse(JSON.stringify(response.data.payload.content))
      // get first item and create a list of item object keys that contains 'CalculatedDemand' string
      const drugstoreHeaders = items[0] ? Object.keys(items[0]).filter(key => key.includes("CalculatedDemand")) : [];


      this.dateRanges = []
      this.packageDiscounts = []
      const fetchedDataRanges = await this.packagesModule.httpGetSellingCustomDateRanges({
        packageOrderGroupGuid: this.currentGroupOrder.groupGuid
      })

      if (fetchedDataRanges) {
        this.dateRanges = fetchedDataRanges
      }

      const fetchedPackageDiscounts = await this.packagesModule.httpGetPackageDiscounts({
        orderGroupGuid: this.currentGroupOrder.groupGuid
      })

      if (fetchedPackageDiscounts) {
        this.packageDiscounts = fetchedPackageDiscounts
      }


      this.orderGeneratorTableHeaders.push(
          {
            key: "listIndex",
            text: "Lp.",
            type: "number",
            width: "40px",
            readonly: this.isOrderPublished,
          }
      );

      this.orderGeneratorTableHeaders.push(
          {
            key: "centralProductCartReference",
            text: "CKT",
            type: "number",
            width: "80px",
            readonly: true
          }
      );
      this.orderGeneratorTableHeaders.push(
          {
            key: "drugstoreClientId",
            text: "Nwbr",
            type: "string",
            width: "80px",
            readonly: true
          }
      );
      this.orderGeneratorTableHeaders.push(
          {
            key: "drugstoreName",
            text: "Apteka",
            type: "string",
            width: "220px",
            readonly: true
          }
      );

      this.orderGeneratorTableHeaders.push(
          {
            key: "name",
            text: "Nazwa",
            type: "string",
            width: "220px",
            readonly: true
          }
      );


      this.orderGeneratorTableHeaders.push(
          {
            key: "drugstoreCompanyName",
            text: "Firma",
            type: "string",
            width: "220px",
            readonly: true,
            sortable: false,
          }
      );

      this.orderGeneratorTableHeaders.push(
          {
            key: "bloz",
            text: "Bloz",
            type: "string",
            width: "80px",
            readonly: true
          }
      );
      this.orderGeneratorTableHeaders.push(
          {
            key: "ean",
            text: "Ean",
            type: "string",
            width: "120px",
            readonly: true
          }
      );

      this.orderGeneratorTableHeaders.push(
          {
            key: "productActiveStockInDrugstore",
            text: "Stan akt.",
            type: "float",
            width: "60px",
            readonly: true,
            sortable: false,
          }
      );

      this.orderGeneratorTableHeaders.push(
          {
            key: "productHoldOnStockInDrugstore",
            text: "Stan wstrz.",
            type: "float",
            width: "60px",
            readonly: true,
            sortable: false,
          }
      );

      // add custom selling date range headers
      this.dateRanges.forEach((dateRange) => {
        var startDateInput = this.formatDateForInput(dateRange.startDate);
        var endDateInput = this.formatDateForInput(dateRange.endDate);
        this.orderGeneratorTableHeaders.push(
            {
              key: dateRange.rangeKey,
              text: `Sprz.Od ${startDateInput} do ${endDateInput}`,
              type: "float",
              width: "80px",
              readonly: true,
              sortable: false,
            });
      });
      this.orderGeneratorTableHeaders.push({
        key: "amount",
        text: "Ilość",
        type: "number",
        width: "60px",
        readonly: this.groupViewMode || this.isOrderPublished,
      });

      drugstoreHeaders.forEach((headerKey) => {
        const drugstoreName = headerKey.split("_").length > 1 ? headerKey.split("_")[1] : headerKey.split("_").length > 0 ? headerKey.split("_")[0] : "Nieznana apteka";
        this.orderGeneratorTableHeaders.push(
            {
              key: headerKey,
              text: drugstoreName,
              type: "float",
              width: "80px",
              readonly: this.isOrderPublished,
              sortable: false,
            }
        );
      });

      this.orderGeneratorTableHeaders.push(
          {
            key: "logisticMinAmountPerDrugstore",
            text: "Min. logist. apteka",
            type: "number",
            width: "80px",
            readonly: this.isOrderPublished,
          }
      );
      this.orderGeneratorTableHeaders.push(
          {
            key: "logisticMinAmountPerOrder",
            text: "Min. logist. zam.",
            type: "number",
            width: "80px",
            readonly: this.isOrderPublished,
          }
      );


      this.orderGeneratorTableHeaders.push(
          {
            key: "suggestedAmount",
            text: "Sug. ilość programu",
            type: "number",
            width: "80px",
            readonly: true
          }
      );

      this.orderGeneratorTableHeaders.push(
          {
            key: "drugstoreSuggestedAmount",
            text: "Sug. ilość apteki",
            type: "number",
            width: "80px",
            readonly: true
          }
      );

      this.orderGeneratorTableHeaders.push(
          {
            key: "notifications",
            text: "Uwagi",
            type: "string",
            width: "200px"
          }
      );


      this.orderGeneratorTableHeaders.push(
          {
            key: "offerPrice",
            text: "Cena oferty",
            type: "float",
            width: "60px",
            readonly: this.isOrderPublished,
          });

      this.orderGeneratorTableHeaders.push(
          {
            key: "calculatedDiscountPercentage",
            text: "Suma Rabat [%]",
            type: "float",
            width: "80px",
            readonly: true
          }
      );
      this.orderGeneratorTableHeaders.push(
          {
            key: "calculatedDiscountQuota",
            text: "Suma Rabat [Kw.]",
            type: "float",
            width: "80px",
            readonly: true
          }
      );
      // add custom selling discount headers
      console.log("PackageDiscounts:");
      console.log(this.packageDiscounts);
      this.packageDiscounts.forEach((discount) => {

        this.orderGeneratorTableHeaders.push(
            {
              key: discount.discountKey,
              text: discount.name,
              type: "float",
              width: "80px",
              readonly: this.isOrderPublished,
              sortable: false,
            });
      });


      this.orderGeneratorTableHeaders.push({
        key: "lastPurchasePriceInDrugstoreTaxExcl",
        text: "Ostatnia cena zakupu netto",
        type: "float",
        width: "100px",
        readonly: true
      })

      this.orderGeneratorTableHeaders.push(
          {
            key: "sellingTax",
            text: "VAT",
            type: "number",
            width: "60px",
            readonly: true
          }
      );

      this.orderGeneratorTableHeaders.push(
          {
            key: "itemOrderedValueTaxExcl",
            text: "Wart. zam. netto",
            type: "float",
            width: "100px",
            readonly: true,
            sortable: false,
          }
      );

      this.orderGeneratorTableHeaders.push(
          {
            key: "itemOrderedValueTaxIncl",
            text: "Wart. zam. brutto",
            type: "float",
            width: "100px",
            readonly: true,
            sortable: false,
          }
      );

      this.orderGeneratorTableHeaders.push(
          {
            key: "itemOrderedValueTaxExclAfterDiscount",
            text: "Wart. zam. netto [Rabat]",
            type: "float",
            width: "100px",
            readonly: true,
            sortable: false,
          }
      );
      this.orderGeneratorTableHeaders.push(
          {
            key: "itemOrderedValueTaxInclAfterDiscount",
            text: "Wart. zam. brutto [Rabat]",
            type: "float",
            width: "100px",
            readonly: true,
            sortable: false,
          }
      );


      this.visibleHeaders = this.orderGeneratorTableHeaders;
      var currentlyAddedColumns = [];
      if(afterSellingRangeAdded){ // add selling ranges as visible columns on default
        currentlyAddedColumns = [...this.dateRanges.map(dateRange => dateRange.rangeKey)];
      }

      if(afterDiscountAdded){ // add discounts as visible columns on default
        currentlyAddedColumns = [...currentlyAddedColumns, ...this.packageDiscounts.map(discount => discount.discountKey)];
      }

      if(afterDrugstoreAdded && this.drugstoresInGridView){ // add drugstores as visible columns on default
        currentlyAddedColumns = [...currentlyAddedColumns,...drugstoreHeaders];
      }

      this.setupInitialHeadersKeysVisible(this.orderGeneratorTableHeaders,currentlyAddedColumns)


      this.orderGeneratorTableData = JSON.parse(JSON.stringify(response.data.payload.content));
      // drugstoreClientId


      this.itemsTotalPages = response.data.payload.totalPages || 1
      this.itemsTotalElements = response.data.payload.totalElements || 0

      this.orderGeneratorTableData.forEach((orderItem) => {
        if (this.orderDrugstoresCurrent) {
          const drugstoreData = this.orderDrugstoresCurrent.find((drugstore) => drugstore.drugstoreClientId === orderItem.drugstoreClientId);
          if (drugstoreData) {
            orderItem['drugstoreName'] = `${drugstoreData.name}`;
            orderItem['drugstoreCompanyName'] = drugstoreData.companyName;
          }
        }

        const itemValues = this.getCalculatedItemValue(orderItem);
        orderItem['itemOrderedValueTaxExcl'] = itemValues.itemOrderedValueTaxExcl;
        orderItem['itemOrderedValueTaxIncl'] = itemValues.itemOrderedValueTaxIncl;
        orderItem['itemOrderedValueTaxExclAfterDiscount'] = itemValues.itemOrderedValueTaxExclAfterDiscount;
        orderItem['itemOrderedValueTaxInclAfterDiscount'] = itemValues.itemOrderedValueTaxInclAfterDiscount;

      });

      const productsResponse = await this.packagesModule.httpGetGroupOrderProductsGuids({orderGroupGuid: this.currentGroupOrder.groupGuid})
      console.log("Central products guids:", productsResponse);
      this.centralProductsGuids = JSON.parse(JSON.stringify(productsResponse.data.payload));
      this.lazyloaderModule.setDisplayLazyLoader(false);
      this.refreshTrigger++;

    },

    formatDateForInput(timestamp) {
      if (!timestamp) return "";
      // timestamp może być liczbą (epoch) lub stringiem ISO
      return dateFormat(new Date(timestamp), "yyyy-mm-dd");
    },

    addProductsToOrderWithWarning(centralProductsToAdd) {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.packagesModule.httpGetGroupOrderProductsGuids({orderGroupGuid: this.currentGroupOrder.groupGuid}).then((response) => {
        this.centralProductsGuids = JSON.parse(JSON.stringify(response.data.payload));
        console.log("Central products guids:", this.centralProductsGuids);
        this.lazyloaderModule.setDisplayLazyLoader(false);
        const centralProductsGuidsToAdd = centralProductsToAdd.map(p => p.guid)
        // check if any of centralProductsGuidsToAdd is already in this.centralProductsGuids
        const alreadyAddedProducts = centralProductsToAdd.filter(product => this.centralProductsGuids.includes(product.guid))
        if (alreadyAddedProducts.length > 0) {
          // ask user if he wants to add duplicated products or add only unique products

          const alreadyAddedProductsContentList = "Produkty zduplikowane:\n" + alreadyAddedProducts.map(p => p.name).join(",\n ")

          Swal.fire({
            title: "Uwaga",
            text: `Niektóre z wybranych produktów są już w zamówieniu. Czy chcesz dodać je ponownie, czy dodać tylko unikalne produkty?`,
            icon: "warning",
            input: 'textarea',
            inputValue: `${alreadyAddedProductsContentList}`,
            inputAttributes: {
              readonly: true,           // use this so users can copy text
              style: 'height: 180px;'   // optional sizing
            },
            showCloseButton: true,
            showConfirmButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: "#556ee6",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: 'Dodaj ponownie',
            cancelButtonText: 'Dodaj tylko unikalne',
            customClass: {
              container: "swal-highest"
            },
          }).then((proceed) => {
            if (proceed.isConfirmed) {
              // user wants to add duplicated products
              log.log("User wants to add duplicated products")
              this.addProductsToOrder(centralProductsGuidsToAdd)
            } else if (proceed.dismiss === Swal.DismissReason.cancel) {
              // user wants to add only unique products
              log.log("User wants to add only unique products")
              const uniqueProductsGuidsToAdd = centralProductsGuidsToAdd.filter(guid => !this.centralProductsGuids.includes(guid))
              if (uniqueProductsGuidsToAdd.length === 0) {
                this.showAddProductSuccessModal()
                return;
              }
              this.addProductsToOrder(uniqueProductsGuidsToAdd)
            } else {
              // user closed the dialog, do nothing
              this.lazyloaderModule.setDisplayLazyLoader(false);
              return;
            }
          });
        } else {
          this.addProductsToOrder(centralProductsGuidsToAdd)
        }

      })


    },
    addProductsToOrder(centralProductsGuidsToAdd) {
      this.lazyloaderModule.setDisplayLazyLoader(true);
      const payload = {
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        centralProductsGuids: centralProductsGuidsToAdd
      }
      this.centralProductsGuids = []
      this.packagesModule.httpAddProductToGroupOrder(payload).then((response) => {
        this.centralProductsGuids = JSON.parse(JSON.stringify(response.data.payload));
        this.refreshItemsData("addProductsToOrder");
        this.lazyloaderModule.setDisplayLazyLoader(false);

        // this.showOrderGeneratorProductsList = false
        this.showAddProductSuccessModal()
      })
    },
    handleApplyFromProductsOrCategories(payload) {
      if (payload && payload.type === 'PRODUCTS') {
        this.addProductsToOrderWithWarning(payload.items)
      } else if (payload && payload.type === 'CATEGORIES') {
        this.addProductsOfCategoriesToOrderWithWarning(payload.items)
      } else if (Array.isArray(payload)) {
        // backward compatibility: plain list of products
        this.addProductsToOrderWithWarning(payload)
      }
    },
    addProductsOfCategoriesToOrderWithWarning(categories) {
      console.log("Adding products of categories to order:")
      console.log(categories)
      this.lazyloaderModule.setDisplayLazyLoader(true);
      const payload = {
        categoriesGuids: categories.map(c => c.guid)
      }
      this.commonModule.httpGetProductsOfCategories(payload).then((response) => {
        const products = JSON.parse(JSON.stringify(response.data.payload));
        this.lazyloaderModule.setDisplayLazyLoader(false);
        if (products == null || products.length === 0) {
          Swal.fire({
            title: "Brak produktów",
            text: "W wybranych kategoriach nie znaleziono żadnych produktów.",
            icon: "info",
            customClass: {
              container: "swal-highest"
            },
          })
          return;
        }
        this.addProductsToOrderWithWarning(products)
      })


    },

    showAddProductSuccessModal() {
      Swal.fire({
        title: "Sukces",
        text: "Dodano produkty do zamówienia.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
        customClass: {
          container: "swal-highest"
        },
      })
    },

    removeItemsFromOrder(groupGuidsToRemove) {
      if (!this.groupViewMode) {
        // removing items one by one not allowed, we allow anlu removing whole product (groupItem) from order, if user wants to remove single item, he must use ignore option or set amount to 0
        Swal.fire({
          title: "Błąd",
          text: "Możesz usuwać tylko całe produkty (wszystkie apteki dla danego towaru). Jeśli chcesz usunąć pojedynczą pozycję, użyj opcji 'Ignoruj' lub ustaw ilość na 0.",
          icon: "error",
          customClass: {
            container: "swal-highest"
          },
        })
        return;
      }


      log.log("Removing items group guids from order:" + groupGuidsToRemove);

      const payload = {
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        itemsGroupGuids: groupGuidsToRemove
      }
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.centralProductsGuids = []
      return this.packagesModule.httpRemoveItemsFromGroupOrder(payload).then((response) => {
        this.centralProductsGuids = JSON.parse(JSON.stringify(response.data.payload));
        this.selectedItemsGuids = []
        this.refreshItemsData("removeItemsFromOrder");
      })
    },


    addDrugstoresToOrder(drugstores) {
      if (drugstores == null || drugstores.length === 0) {
        this.showDrugstoresSelectList = false;
        return;
      }

      // adding to drugstores list
      var currentDrugstores = JSON.parse(JSON.stringify(this.orderDrugstoresCurrent));
      if (currentDrugstores) {
        drugstores.forEach(drugstore => {
          const exists = currentDrugstores.some(
              d => d.drugstoreClientId === drugstore.drugstoreClientId
          );
          if (!exists) {
            currentDrugstores.push(drugstore);
          }
        });

        this.notifyDrugstoresTableNewData(currentDrugstores)
      }


      const drugstoresClientIdsToAdd = drugstores.map(d => d.drugstoreClientId)
      const payload = {
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        drugstoresClientIds: drugstoresClientIdsToAdd
      }
      this.lazyloaderModule.setDisplayLazyLoader(true);

      this.packagesModule.httpAddDrugstoreToGroupOrder(payload).then((response) => {
        this.lazyloaderModule.setDisplayLazyLoader(false);
        this.showDrugstoresSelectList = false;
        this.orderDrugstoresCurrent = response.data.payload // fetching new drugstores list after adding
        if (this.orderDrugstoresCurrent == null || this.orderDrugstoresCurrent.length === 0) {
          // may happen in the exception response during adding the drugstores
          this.lazyloaderModule.setDisplayLazyLoader(true);
          this.packagesModule.httpGetDrugstoresForGroupOrder({orderGroupGuid: this.currentGroupOrder.groupGuid}).then((response) => {
            this.orderDrugstoresCurrent = response.data.payload
            this.lazyloaderModule.setDisplayLazyLoader(false);
          })
        }


        this.refreshItemsData("addDrugstoresToOrder",false,false,true);
      })
    },

    removeDrugstoresFromOrder(drugstoresClientIdsToRemove) {
      var currentDrugstores = JSON.parse(JSON.stringify(this.orderDrugstoresCurrent));
      // remove from currentDrugstores items that have drugstoreClientId in drugstoresClientIdsToRemove
      currentDrugstores = currentDrugstores.filter(drugstore => !drugstoresClientIdsToRemove.includes(drugstore.drugstoreClientId))
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.notifyDrugstoresTableNewData(currentDrugstores)


      const payload = {
        orderGroupGuid: this.currentGroupOrder.groupGuid,
        drugstoresClientIds: drugstoresClientIdsToRemove
      }
      return this.packagesModule.httpRemoveDrugstoreFromGroupOrder(payload).then((response) => {
        this.orderDrugstoresCurrent = response.data.payload // fetching new drugstores list after removing
        this.refreshItemsData("removeDrugstoresFromOrder")
      }).then(() => {
        this.lazyloaderModule.setDisplayLazyLoader(false);
      })
    },
    handleApplyFromDrugstoresOrGroups(payload) {
      if (!payload || !payload.type) {
        return;
      }

      // 1) Z tab-a "Apteki" dostajesz listę obiektów aptek (tak jak dotychczas)
      if (payload.type === "DRUGSTORES") {
        const selectedDrugstores = payload.items || [];
        this.addDrugstoresToOrder(selectedDrugstores);
        return;
      }

      // 2) Z tab-a "Grupy aptek" dostajesz listę grup
      if (payload.type === "GROUPS") {
        const selectedGroups = payload.items || [];
        if (selectedGroups.length === 0) {
          return;
        }
        console.log("Selected groups:", selectedGroups);
        // a) jeśli grupa już zawiera drugstores (czasem backend zwraca od razu):
        var allDrugstoreClientIds = []
        selectedGroups.forEach(g => {
          if (g && Array.isArray(g.drugstoresClientIds) && g.drugstoresClientIds.length > 0) {
            allDrugstoreClientIds.push(...g.drugstoresClientIds);
          }
        });

        this.lazyloaderModule.setDisplayLazyLoader(true);
        this.commonModule.httpGetDrugstoresForClientIds({drugstoresClientIds: allDrugstoreClientIds}).then((response) => {
          console.log("Fetched drugstore details for allDrugstoreClientIds:", response.data.payload);
          if (response.status === 200) {
            const fetchedDrugstoresData = response.data.payload;
            this.addDrugstoresToOrder(fetchedDrugstoresData);

          }
          apiRequestsHelper.handleResponseWithDialogs(response, false);
        })
            .catch((error) => {
              apiRequestsHelper.catchResponseError(error, "httpGetDrugstoresForClientIds");
            })
      }
    },
    setupInitialHeadersKeysVisible(allHeaders, headersAddedCurrently = []) {
      // setting default initial list of visible headers keys
      console.log("Setting up initial headers keys visible", allHeaders);
      var initiallyVisibleHeaderKeys = [];
      for (let i = 0; i < allHeaders.length; i++) {
        const header = allHeaders[i];
        if (header.key === 'listIndex') {
          if (this.groupViewMode === true) {
            initiallyVisibleHeaderKeys.push(header.key);// list index should be visible only for group view mode
          }
        } else if (header.key === 'drugstoreName' || header.key === 'drugstoreClientId') {
          if (this.groupViewMode === false) {
            initiallyVisibleHeaderKeys.push(header.key);// drugstoreName and drugstoreCompanyName should be visible only for single view mode
          }
        } else if (header.key === 'ean' || header.key === 'drugstoreCompanyName') {
          // do nothing - do not push those fields to initiallyVisibleHeaderKeys (the are optionally visible)
        } else {
          initiallyVisibleHeaderKeys.push(header.key);
        }
      }
      return this.loadUserProfileViewConfig().then(() => {
        if(this.visibleHeaderKeys === null || this.visibleHeaderKeys.length === 0){
          // if user has no saved settings, we should set visibleHeaderKeys to default initiallyVisibleHeaderKeys
          this.visibleHeaderKeys = [...initiallyVisibleHeaderKeys];
        }
        //overriding static headers with profile setting headers
        initiallyVisibleHeaderKeys = initiallyVisibleHeaderKeys.filter(headerKey => this.visibleHeaderKeys.includes(headerKey));
        // adding headers that was added to currently like selling ranges or discounts
        for(let i = 0; i < headersAddedCurrently.length; i++){
          const headerKey = headersAddedCurrently[i];
          if(!initiallyVisibleHeaderKeys.includes(headerKey)){
            initiallyVisibleHeaderKeys.push(headerKey);
          }
        }

        this.updateVisibleColumns(initiallyVisibleHeaderKeys);
      })



    },
    lockOrderForUserScope(currentOrderGroupGuid) {
      const payload = {
        orderGroupGuid: currentOrderGroupGuid
      }
      this.packagesModule.acquirePackageOrderViewLock(payload).then((response) => {
        console.log("Acquired lock for order:", response.data.payload);
        if (!response.data.payload.acquired) {
          Swal.fire(
              "Zamówienie otwarte przez innego użytkownika",
              "Aktualnie używa: " + (response.data.payload.ownerUserId || "ktoś inny"),
              "warning"
          );
          router.push("/packages-manager/groupOrders");
          return;
        }

        this.heartbeatTimer = setInterval(async () => {
          const res = await this.packagesModule.renewPackageOrderViewLock(payload);
          console.log("Renew lock for order:", res.data.payload);
          if (!res.data.payload.renewed) {
            this.stopHeartbeatTimer()
            Swal.fire("Utracono blokadę", "Proces wygasł lub został przejęty przez innego użytkownika.", "warning").then(() => {
              // router.push('/packages-manager/groupOrders');
              router.push("/packages-manager/groupOrders");
            })

          }
        }, 45000); // 45s
      })
    },
    stopHeartbeatTimer() {
      if (this.heartbeatTimer) {
        clearInterval(this.heartbeatTimer);
        this.heartbeatTimer = null;
      }
    },

    handleDrugstoresInGridViewChange(event){
      console.log("Drugstores in grid view changed:", event.target.checked);
      this.saveGroupingViewSetting();
      this.refreshItemsData("handleDrugstoresInGridViewChange");
    },
    handleGroupViewModeChange(event){
      console.log("handleGroupViewModeChange view changed:", event.target.checked);
      const checked = event.target.checked;
      if(!checked){
        this.drugstoresInGridView = false; // disable drugstores in grid view if group view mode is disabled
      }
      this.saveGroupingViewSetting();
      this.refreshItemsData("handleGroupViewModeChange");
    },
    async loadUserProfileViewConfig() {
      try {
        await loadUserProfileViewConfigRuntime({
          viewKey: this.currentViewKey,
          context: this.currentViewContext,
          onLoadingChange: (value) => {
            this.isApplyingUserProfileConfig = value;
          },
          onSettingsLoaded: (settings) => {
            this.userProfileSettings = [...settings];
            this.applyUserProfileSettingsToComponent(settings);
          },
        });
      } catch (e) {
        console.error("Błąd podczas ładowania konfiguracji widoku użytkownika:", e);
      }
    },
    applyUserProfileSettingsToComponent(settings) {
      const applied = applyTableUserProfileSettings({
        settings,
        fallbackVisibleColumns: [],
        fallbackSortingKey: this.sortingKey,
        fallbackSortingDirection: this.sortingDirection,
        tableViewType: this.groupViewMode && this.drugstoresInGridView ? "GROUPED_GRID" : this.groupViewMode ? "GROUPED" : "DEFAULT"
      });
      console.log("Applied settings VisibleColumns to component:", applied.visibleColumns.map(item => item.key));
      this.visibleHeaderKeys = [...applied.visibleColumns.map(item => item.key)];
      this.sortingKey = applied.sortingKey;
      this.sortingDirection = applied.sortingDirection;

      const packageOrderGroupingSetting = findSettingByKey(settings, "PACKAGE_ORDER_ITEMS_GROUPING_VIEW");
      const parsedPackageOrderGroupingSetting = parseJsonSettingValue(packageOrderGroupingSetting, null);
      this.drugstoresInGridView = parsedPackageOrderGroupingSetting?.drugstoresInGridView || false;
      this.groupViewMode = parsedPackageOrderGroupingSetting?.groupViewMode || false;
    },

    async saveVisibleColumns(columnDefinitions) {
      console.log("Saving visible columns:", columnDefinitions);
      try {
        const result = await saveVisibleColumnsRuntime({
          currentSettings: this.userProfileSettings,
          columnDefinitions,
          viewKey: this.currentViewKey,
          context: this.currentViewContext,
          tableViewType: this.groupViewMode && this.drugstoresInGridView ? "GROUPED_GRID" : this.groupViewMode ? "GROUPED" : "DEFAULT"
        });

        this.userProfileSettings = [...result.savedSettings];
        this.visibleHeaderKeys = [...result.savedVisibleColumns.map(item => item.key)];
      } catch (e) {
        console.error("Błąd podczas zapisu ustawienia visible columns:", e);
      }
    },
    async saveSortingSetting(sortColumn, sortDirection) {
      try {
        const result = await saveSortingSettingRuntime({
          currentSettings: this.userProfileSettings,
          sortColumn,
          sortDirection,
          viewKey: this.currentViewKey,
          context: this.currentViewContext,
        });

        this.userProfileSettings = [...result.savedSettings];
      } catch (e) {
        console.error("Błąd podczas zapisu ustawienia sortowania:", e);
      }
    },

    async saveGroupingViewSetting() {
      try {
        const result = await saveGroupingViewSettingRuntime({
          currentSettings: this.userProfileSettings,
          groupViewMode: this.groupViewMode,
          drugstoresInGridView: this.drugstoresInGridView,
          viewKey: this.currentViewKey,
          context: this.currentViewContext,
        });

        this.userProfileSettings = [...result.savedSettings];
      } catch (e) {
        console.error("Błąd podczas zapisu ustawienia grupowania:", e);
      }
    },

  },
  watch: {
    currentPage: {
      handler() {
        this.refreshItemsData("currentPage watch");
      },
      deep: true,
    },

    currentFocusedCell: {
      handler() {
        // Cancel last timeout if exists
        if (this.logisticDetailsDebounceTimeout) {
          clearTimeout(this.logisticDetailsDebounceTimeout);
        }
        // Set new timeout to prevent to many api requests when user is navigating through cells very quickly
        this.logisticDetailsDebounceTimeout = setTimeout(() => {
          if (this.isLogisticContainerOpen && this.currentFocusedCell != null) {
            this.fetchLogisticDetails(this.currentFocusedCell);
          }
        }, 250);
      },
      deep: true,
    }

  },

  beforeRouteLeave(to, from, next) {
    this.stopHeartbeatTimer();
    // najlepiej też release (best effort)
    this.packagesModule.releasePackageOrderViewLock({orderGroupGuid: this.currentGroupOrder.groupGuid}).finally(() => next());
  },

  // 2) Gdy komponent jest niszczony (bez keep-alive)
  beforeUnmount() {
    this.stopHeartbeatTimer();
    this.packagesModule.releasePackageOrderViewLock({orderGroupGuid: this.currentGroupOrder.groupGuid});
  },

  // 3) Gdy masz <keep-alive> (wtedy nie ma unmount, tylko deactivate)
  deactivated() {
    this.stopHeartbeatTimer();
    this.packagesModule.releasePackageOrderViewLock({orderGroupGuid: this.currentGroupOrder.groupGuid});
  },

  mounted() {
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-package me-1"></i> Zamówienia centralne - Generator`)
  },

  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      const groupGuidFromUrlParam = this.$route.query.editOrderGroupGuid // in vue router it is added as available param
      const passedOrderGroupGuid = this.editOrderGroupGuid || groupGuidFromUrlParam || null;

      if (passedOrderGroupGuid != null && passedOrderGroupGuid.length > 0) {
        this.lockOrderForUserScope(passedOrderGroupGuid);
        this.lazyloaderModule.setDisplayLazyLoader(true);
        this.editContextOn = true;
        this.lazyloaderModule.setProgressBarMessage("Pobieranie danych o zamówieniu.");
        this.packagesModule.httpGetPackageGroupOrderByGuid({orderGroupGuid: passedOrderGroupGuid}).then((response) => {
          const fetchedOrder = response.data.payload
          const orderCreationDate = new Date(fetchedOrder.orderCreationDate).toLocaleString('sv', {timeZone: 'Europe/Warsaw'}).split(' ')[0]; // format yyyy-mm-dd
          this.currentGroupOrder = fetchedOrder
          this.currentGroupOrder.orderCreationDate = orderCreationDate;
          this.packagesModule.httpGetDrugstoresForGroupOrder({orderGroupGuid: this.currentGroupOrder.groupGuid}).then((response) => {
            this.orderDrugstoresCurrent = response.data.payload
          })
        }).then(() => {
          this.lazyloaderModule.setDisplayLazyLoader(false);
          this.loadUserProfileViewConfig().then(() => {
            // console.log("Loaded user profile view config",this.userProfileSettings);
            this.refreshItemsData("created");
          })

        });


      } else {
        this.editContextOn = false; // just in case

      }


    })


  },
};
</script>

<style scoped>
.generator-table-section {
  /* Outer container takes full viewport */
  width: 100vw;
  /* height: 200vh; */ /* Removed so it grows with content */

  /* Optional: if you have other content above/below,
     you can tweak this with calc(), e.g.:
     height: calc(100vh - 100px); */

  display: flex;
  flex-direction: column;

}


.scrollable-content {

}


.package-order-generator-action-buttons {
  text-align: right;
  margin-right: 4px;
  margin-bottom: 16px;
  margin-top: 16px;
}

.save-buttons {
  margin-left: 2px;
}

.items-management-btn {
  text-align: center;
  width: 100%;
}


.center-show {
  text-align: center;
}

.products-mass-actions-section {
  background: #f3f2f1;
  border: 1px dashed #c8c6c4;
  padding: 10px;
  border-radius: 4px;
  text-align: left;
  font-style: normal;
  font-size: 13px;
}

.package-orders-generator-site {

}

.mass-actions-btn {
  margin-right: 4px;

}

</style>
